window.theme=window.theme||{},void 0===window.Shopify&&(window.Shopify={}),Shopify.bind=function(e,t){return function(){return e.apply(t,arguments)}},Shopify.setSelectorByValue=function(e,t){for(var s=0,r=e.options.length;s<r;s++){var i=e.options[s];if(t==i.value||t==i.innerHTML)return e.selectedIndex=s}},Shopify.addListener=function(e,t,s){e.addEventListener?e.addEventListener(t,s,!1):e.attachEvent("on"+t,s)},Shopify.postLink=function(e,t){var s,r=(t=t||{}).method||"post",i=t.parameters||{},a=document.createElement("form");for(s in a.setAttribute("method",r),a.setAttribute("action",e),i){var o=document.createElement("input");o.setAttribute("type","hidden"),o.setAttribute("name",s),o.setAttribute("value",i[s]),a.appendChild(o)}document.body.appendChild(a),a.submit(),document.body.removeChild(a)},Shopify.CountryProvinceSelector=function(e,t,s){this.countryEl=document.getElementById(e),this.provinceEl=document.getElementById(t),this.provinceContainer=document.getElementById(s.hideElement||t),Shopify.addListener(this.countryEl,"change",Shopify.bind(this.countryHandler,this)),this.initCountry(),this.initProvince()},Shopify.CountryProvinceSelector.prototype={initCountry:function(){var e=this.countryEl.getAttribute("data-default");Shopify.setSelectorByValue(this.countryEl,e),this.countryHandler()},initProvince:function(){var e=this.provinceEl.getAttribute("data-default");e&&0<this.provinceEl.options.length&&Shopify.setSelectorByValue(this.provinceEl,e)},countryHandler:function(e){var t=(r=this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),s=JSON.parse(t);if(this.clearOptions(this.provinceEl),s&&0==s.length)this.provinceContainer.style.display="none";else{for(var r,i=0;i<s.length;i++)(r=document.createElement("option")).value=s[i][0],r.innerHTML=s[i][1],this.provinceEl.appendChild(r);this.provinceContainer.style.display=""}},clearOptions:function(e){for(;e.firstChild;)e.removeChild(e.firstChild)},setOptions:function(e,t){var s=0;for(t.length;s<t.length;s++){var r=document.createElement("option");r.value=t[s],r.innerHTML=t[s],e.appendChild(r)}}},theme.config={mediaQueries:{landscapeAll:"screen and (orientation: landscape)",landscape:"screen and (orientation: landscape), screen and (min-width: 48rem)",belowTablet:"screen and (max-width: 47.99rem)",tablet:"screen and (min-width: 48rem)",belowLaptop:"screen and (max-width: 63.99rem)",laptop:"screen and (min-width: 64rem)",belowDesktop:"screen and (max-width: 64rem)",desktop:"screen and (min-width: 64.01rem)",belowWidescreen:"screen and (max-width: 79.99rem)",widescreen:"screen and (min-width: 80rem)",belowExtrawide:"screen and (max-width: 89.99rem)",extrawide:"screen and (min-width: 90rem)"},money:{format:`${window.currency.symbol||"$"}{{amount}}`},upsellLimit:6},theme.utils={a11y:{getFocusableElements(e){return Array.from(e.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"))},_trapFocusHandlers:{},trapFocus(t,e=t){var s=theme.utils.a11y.getFocusableElements(t),r=s[0],i=s[s.length-1];theme.utils.a11y.removeTrapFocus(),theme.utils.a11y._trapFocusHandlers.focusin=e=>{e.target!==t&&e.target!==i&&e.target!==r||document.addEventListener("keydown",theme.utils.a11y._trapFocusHandlers.keydown)},theme.utils.a11y._trapFocusHandlers.focusout=function(){document.removeEventListener("keydown",theme.utils.a11y._trapFocusHandlers.keydown)},theme.utils.a11y._trapFocusHandlers.keydown=function(e){"TAB"===e.code.toUpperCase()&&(e.target!==i||e.shiftKey||(e.preventDefault(),r.focus()),e.target===t||e.target===r)&&e.shiftKey&&(e.preventDefault(),i.focus())},document.addEventListener("focusout",theme.utils.a11y._trapFocusHandlers.focusout),document.addEventListener("focusin",theme.utils.a11y._trapFocusHandlers.focusin),e.focus()},removeTrapFocus(e=null){document.removeEventListener("focusin",theme.utils.a11y._trapFocusHandlers.focusin),document.removeEventListener("focusout",theme.utils.a11y._trapFocusHandlers.focusout),document.removeEventListener("keydown",theme.utils.a11y._trapFocusHandlers.keydown),e&&e.focus()}},prepareTransition(e){e.addEventListener("transitionend",()=>{e.classList.remove("is-transitioning")});let t=0;const s=getComputedStyle(e);["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"].forEach(e=>t=t||parseFloat(s.getPropertyValue(e))),0!=t&&(e.classList.add("is-transitioning"),e.offsetWidth)},defaultTo:function(e,t){return null==e||e!=e?t:e},formatMoney(e,t){"string"==typeof e&&(e=e.replace(".",""));var s="",r=/\{\{\s*(\w+)\s*\}\}/,t=t||theme.config.money.format;function i(e,t,s,r){return t=theme.utils.defaultTo(t,2),s=theme.utils.defaultTo(s,","),r=theme.utils.defaultTo(r,"."),isNaN(e)||null==e?0:(t=(e=(e/100).toFixed(t)).split("."))[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+s)+(t[1]?r+t[1]:"")}switch(t.match(r)[1]){case"amount":s=i(e,2);break;case"amount_no_decimals":s=i(e,0);break;case"amount_with_space_separator":s=i(e,2," ",".");break;case"amount_no_decimals_with_comma_separator":s=i(e,0,",",".");break;case"amount_no_decimals_with_space_separator":s=i(e,0," ")}return t.replace(r,s)},serializeForm:e=>{var t={},s=new FormData(e);for(const i of s.keys()){var r=/(?:^(properties\[))(.*?)(?:\]$)/;r.test(i)?(t.properties=t.properties||{},t.properties[r.exec(i)[2]]=s.get(i)):t[i]=s.get(i)}return JSON.stringify(t)},debounce(t,s){let r;return(...e)=>{clearTimeout(r),r=setTimeout(()=>t.apply(this,e),s)}},getSiblings(e,t){var s,r=[];let i;for(s of i=t?e.parentNode.querySelectorAll(":scope > "+t):e.parentNode.children)s!==e&&r.push(s);return r},refreshElements(e,t,s){e.forEach(e=>{const a=t.querySelectorAll(e);s.querySelectorAll(e).forEach((e,t)=>{var s,r,i;a[t]?null!=e.getAttribute("js-accordion-item")?(s=e.querySelector("[js-accordion-header]").getAttribute("aria-expanded"),r=e.querySelector("[js-accordion-content]").getAttribute("aria-hidden"),(i=a[t]).querySelector("[js-accordion-header]").setAttribute("aria-expanded",s),i.querySelector("[js-accordion-content]").setAttribute("aria-hidden",r),e.innerHTML=i.innerHTML):e.innerHTML=a[t].innerHTML:e.remove()})})},handleize(e){return e.toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-$/,"").replace(/^-/,"")},getCookie(e){for(var t=e+"=",s=decodeURIComponent(document.cookie).split(";"),r=0;r<s.length;r++){for(var i=s[r];" "==i.charAt(0);)i=i.substring(1);if(0==i.indexOf(t))return i.substring(t.length,i.length)}return""},setCookie(e,t,s){var r=new Date,s=(r.setTime(r.getTime()+24*s*60*60*1e3),"expires="+r.toUTCString());document.cookie=e+"="+t+";"+s+";path=/"}};class CartAPI{static async get(){CartAPI._trigger(CartAPI._events.fetch.before);try{var e=await(await fetch("/cart.js")).json();return CartAPI._trigger(CartAPI._events.fetch.complete,{cart:e}),e}catch(e){CartAPI._trigger(CartAPI._events.fetch.error,{error:e}),CartAPI._onError(e)}}static async add(t){CartAPI._trigger(CartAPI._events.add.before);try{let e=await fetch("/cart/add.js",{method:"POST",body:JSON.stringify(t),...CartAPI._fetchConfig});if((e=await e.json()).status)throw e;return CartAPI._trigger(CartAPI._events.add.complete,{item:e}),e}catch(e){CartAPI._trigger(CartAPI._events.add.error,{error:e}),CartAPI._onError(e)}}static async addFromForm(t){if(t&&t instanceof HTMLElement){CartAPI._trigger(CartAPI._events.add.before);try{let e=await fetch("/cart/add.js",{method:"POST",body:theme.utils.serializeForm(t),...CartAPI._fetchConfig});if((e=await e.json()).status)throw e;return CartAPI._trigger(CartAPI._events.add.complete,{item:e}),e}catch(e){CartAPI._trigger(CartAPI._events.add.error,{error:e}),CartAPI._onError(e)}}else console.error("Invalid form in CartAPI call")}static async change(t){CartAPI._trigger(CartAPI._events.update.before);try{let e=await fetch("/cart/change.js",{method:"POST",body:JSON.stringify(t),...CartAPI._fetchConfig});if((e=await e.json()).status)throw e;return CartAPI._trigger(CartAPI._events.update.complete,{cart:e}),e}catch(e){CartAPI._trigger(CartAPI._events.update.error,{error:e}),CartAPI._onError(e)}}static async update(t){CartAPI._trigger(CartAPI._events.update.before);try{let e=await fetch("/cart/update.js",{method:"POST",body:JSON.stringify(t),...CartAPI._fetchConfig});if((e=await e.json()).status)throw e;return CartAPI._trigger(CartAPI._events.update.complete,{cart:e}),e}catch(e){CartAPI._trigger(CartAPI._events.update.error,{error:e}),CartAPI._onError(e)}}static async clear(){CartAPI._trigger(CartAPI._events.update.before);try{let e=await fetch("/cart/clear.js",{method:"POST",...CartAPI._fetchConfig});if((e=await e.json()).status)throw data;return CartAPI._trigger(CartAPI._events.update.complete,{cart:e}),e}catch(e){CartAPI._trigger(CartAPI._events.update.error,{error:e}),CartAPI._onError(e)}}static _onError(e){console.error(`CartApi Error: 
        status: ${e.status}
        message: ${e.message}
        description: `+e.description)}static _trigger(e,t={}){document.dispatchEvent(new CustomEvent(e,{detail:t}))}}CartAPI._fetchConfig={credentials:"same-origin",headers:{"Content-Type":"application/json",Accept:"application/javascript"}},CartAPI._events={update:{before:"cart:update:before",complete:"cart:update:complete",error:"cart:update:error"},fetch:{before:"cart:fetch:before",complete:"cart:fetch:complete",error:"cart:fetch:error"},add:{before:"cart:add:before",complete:"cart:add:complete",error:"cart:add:error"}};class FocusableWidget extends HTMLElement{constructor(e={}){if(super(),!e.name)throw new Error(`Focusable Widget(${e.name}) must have a name`);if(!this.id)throw new Error(e.name+" must have an id");if(!e.background)throw new Error(`Focusable Widget(${e.name}) must have a background`);this._clientConfig=e,this._init(e)}open(){if(!this._isOpen)return this._closeFocusableWidgets(),this.toggle()}close(){if(this._isOpen)return this.toggle()}toggle(){return theme.utils.prepareTransition(this),this._toggleClasses(),this._toggleAccessibilityAttributes(),this._isOpen?(theme.utils.a11y.removeTrapFocus(this),this._unbindEvents(),this._dispatchEvents(this._events.close,["close"])):(theme.utils.a11y.trapFocus(this),this._bindEvents(),this._dispatchEvents(this._events.open,["open"])),this._isOpen=!this._isOpen,this}reinitWidget(){this._init(this._clientConfig)}get isOpen(){return this._isOpen}_init({name:e,background:t,widgetOpenClasses:s=[],bodyOpenClasses:r=[],attributes:i={}}){this._name=e,this._isOpen=!1,this._selectors={background:t,open:this.getAttribute("open"),close:this.getAttribute("close")},this._nodes={background:document.querySelector(this._selectors.background)},this._events={open:["focusable-widget:open",e+":open",this.id+":open"],close:["focusable-widget:close",e+":close",this.id+":close"]},this._config={open:document.querySelectorAll(this._selectors.open),close:document.querySelectorAll(this._selectors.close),attributes:{"data-focusable-widget":"true","aria-hidden":"true",tabindex:0,...i},widgetOpenClasses:["open",this.getAttribute("open-class")].concat(s),bodyOpenClasses:["js-focusable-widget-open",`js-${e}-open`,this.getAttribute("body-open-class")].concat(r)},this._validateConfig(),this._addAccessibilityAttributes(),this._setupListeners()}_validateConfig(){if(this._config.open&&this._config.open.length||console.warn(`WARN: ${this._name}: no open triggers found. Check your ${this._name} 'open' attribute, or add a trigger (if needed)`),!this._config.close||!this._config.close.length)throw new Error(`${this._name}: invalid close trigger selector, no elements found. Check your ${this._name} 'close' attribute`)}_setupListeners(){this._config.open.forEach(e=>e.addEventListener("click",this._open.bind(this))),this._config.close.forEach(e=>e.addEventListener("click",this._close.bind(this))),this.addEventListener("click",e=>e.stopPropagation())}_open(e){e&&(e.preventDefault(),e.stopPropagation()),this.open()}_close=e=>{e&&(e.preventDefault(),e.stopPropagation()),this.close()};_closeFocusableWidgets(){document.querySelectorAll("[data-focusable-widget].open").forEach(e=>e.close())}_dispatchEvents(e,t){e.forEach(e=>document.dispatchEvent(new CustomEvent(e))),t&&t.length&&t.forEach(e=>this.dispatchEvent(new CustomEvent(e)))}_bindEvents(){document.addEventListener("keyup",this._onKeyUp),this._nodes.background.addEventListener("click",this._close),this._nodes.background.addEventListener("touchmove",this._onTouchMove)}_unbindEvents(){document.removeEventListener("keyup",this._onKeyUp),this._nodes.background.removeEventListener("click",this._close),this._nodes.background.removeEventListener("touchmove",this._onTouchMove)}_toggleClasses(){this._isOpen?(this._config.bodyOpenClasses.forEach(e=>{e&&document.body.classList.remove(e)}),this._config.widgetOpenClasses.forEach(e=>{e&&this.classList.remove(e)})):(this._config.bodyOpenClasses.forEach(e=>{e&&document.body.classList.add(e)}),this._config.widgetOpenClasses.forEach(e=>{e&&this.classList.add(e)}))}_toggleAccessibilityAttributes(){this._isOpen?(this.setAttribute("aria-hidden","true"),this.setAttribute("tabindex","-1"),this._config.open.forEach(e=>e.setAttribute("aria-expanded","false")),this._config.close.forEach(e=>e.setAttribute("aria-expanded","false"))):(this.setAttribute("aria-hidden","false"),this.setAttribute("tabindex","0"),this._config.open.forEach(e=>e.setAttribute("aria-expanded","true")),this._config.close.forEach(e=>e.setAttribute("aria-expanded","true")))}_addAccessibilityAttributes(){var e=e=>{e.setAttribute("tabindex","0"),e.setAttribute("aria-expanded","false"),e.setAttribute("aria-controls",this.id)};for(const t in this._config.attributes)this.setAttribute(t,this._config.attributes[t]);this._config.open.forEach(e),this._config.close.forEach(e)}_onKeyUp=e=>{"ESCAPE"===e.code.toUpperCase()&&this.close()};_onTouchMove=()=>!1}if(theme.ssCookies={ssUserId:theme.utils.getCookie("ssUserId"),ssSessionIdNamespace:theme.utils.getCookie("ssSessionIdNamespace"),ssShopperId:theme.utils.getCookie("ssShopperId"),ssCartProducts:theme.utils.getCookie("ssCartProducts"),ssViewedProducts:theme.utils.getCookie("ssViewedProducts"),ssPageLoadId:uuidv4()},!theme.ssCookies.ssUserId){const P0=uuidv4();theme.utils.setCookie("ssUserId",P0,365),theme.ssCookies.ssUserId=P0}if(!theme.ssCookies.ssSessionIdNamespace){const Q0=uuidv4();theme.utils.setCookie("ssSessionIdNamespace",Q0),theme.ssCookies.ssSessionIdNamespace=Q0}theme.CartAPI=window.CartAPI=CartAPI,theme.AjaxCart=document.querySelector("s-ajaxcart");class Drawer extends FocusableWidget{constructor(){super({name:"drawer",background:".drawer-background"});var e=this.getAttribute("position");if(!e)throw new Error("drawer must have position attribute");this._position=e,this._config.bodyOpenClasses.push(`js-drawer-${e}-open`),this._clientConfig.bodyOpenClasses=[`js-drawer-${e}-open`]}get position(){return this._position}}class Modal extends FocusableWidget{constructor(){super({name:"modal",background:".modal-background",bodyOpenClasses:"js-modal-open"}),this.openOnLoad="true"===this.getAttribute("data-open-on-load"),this.cookieName=this.getAttribute("data-cookie-name"),this.cookieDays=parseInt(this.getAttribute("data-cookie-days"))||30}connectedCallback(){super.connectedCallback?.(),this._checkAutoOpen()}_checkAutoOpen(){this.openOnLoad&&!this._isDismissed()&&setTimeout(()=>this.open(),500)}_isDismissed(){return!!this.cookieName&&document.cookie.split(";").some(e=>e.trim().startsWith(this.cookieName+"="))}_setDismissedCookie(){var e;this.cookieName&&((e=new Date).setTime(e.getTime()+24*this.cookieDays*60*60*1e3),document.cookie=`${this.cookieName}=true; expires=${e.toUTCString()}; path=/`)}close(){return super.close(),this._setDismissedCookie(),this}}class Accordion extends HTMLElement{constructor(){super(),this._selectors={accordion:"[js-accordion]",accordionItem:"[js-accordion-item]",accordionHeader:"[js-accordion-header]",accordionContent:"[js-accordion-content]"}}connectedCallback(){this.buttons=this.querySelectorAll(this._selectors.accordionHeader),this.buttons.forEach(e=>{e.addEventListener("click",this._toggleContent)}),this.content=this.querySelectorAll(this._selectors.accordionContent)}_toggleContent=e=>{e.stopImmediatePropagation();var e=e.currentTarget,t=this.querySelector("#"+e.getAttribute("aria-controls")),s=theme.utils.getSiblings(e.parentElement,this._selectors.accordionItem);"false"==e.getAttribute("aria-expanded")?(e.setAttribute("aria-expanded",!0),theme.utils.prepareTransition(t),this._expandSection(t),this.dataset.manualCollapse||(s.forEach(e=>{var t=e.querySelector(this._selectors.accordionHeader),e=e.querySelector("#"+t.getAttribute("aria-controls"));"true"==t.getAttribute("aria-expanded")&&(t.setAttribute("aria-expanded",!1),this._collapseSection(e))}),this._updateMobileNavAccordionTriggers(!0,e,s))):(e.setAttribute("aria-expanded",!1),this._collapseSection(t),this._updateMobileNavAccordionTriggers(!1,e))};_collapseSection(e){e.setAttribute("aria-hidden",!0)}_expandSection(e){e.setAttribute("aria-hidden",!1)}_updateMobileNavAccordionTriggers(e,t,s){t.classList.contains("mobile-nav__accordion-header")&&(e?(t.classList.remove("opacity-40"),s.forEach(e=>{e.querySelector(this._selectors.accordionHeader).classList.add("opacity-40")})):this.buttons.forEach(e=>{e.classList.remove("opacity-40")}))}}class Tabs extends HTMLElement{constructor(){super()}connectedCallback(){this._elements={tabs:this.querySelectorAll("[js-tab]"),tabList:this.querySelectorAll("[js-tab-list]"),tabPanel:this.querySelectorAll("[js-tab-panel]")},this._tabEventListener(),this._tabListListener()}_tabEventListener=()=>{var e=this._elements["tabs"];e.forEach(e=>e.addEventListener("click",this._showTabPanel))};_showTabPanel=e=>{var t=e.currentTarget,s=this._elements["tabs"];for(let e=0;e<s.length;e++)s[e].setAttribute("aria-selected","false");e.target.setAttribute("aria-selected","true");var e=t.getAttribute("aria-controls"),r=document.querySelectorAll("[role=tabpanel]");for(let e=0;e<r.length;e++)r[e].setAttribute("aria-hidden","true");document.getElementById(e).setAttribute("aria-hidden","false")};_tabListListener=()=>{var e=this._elements["tabList"];e.forEach(e=>e.addEventListener("keydown",this._tabListKeydown))};_tabListKeydown=e=>{37==e.keyCode&&($("[aria-selected=true]").prev().click().focus(),e.preventDefault()),38==e.keyCode&&($("[aria-selected=true]").prev().click().focus(),e.preventDefault()),39==e.keyCode&&($("[aria-selected=true]").next().click().focus(),e.preventDefault()),40==e.keyCode&&($("[aria-selected=true]").next().click().focus(),e.preventDefault())}}class AjaxCart extends HTMLElement{constructor(){super(),this._Ajaxcart,this._selectors={drawer:"[js-cart-drawer]",upsellData:"#AjaxCartUpsellData[js-upsell-data]",upsellDataB:"#AjaxCartUpsellDataB[js-upsell-data-b]",counter:"[js-cart-counter]"},this._internalEvents={fetch:"ajaxcart:fetch",open:"ajaxcart:open",close:"ajaxcart:close",refreshUpsell:"ajaxcart:upsell:refresh"},this._config={shippingThreshold:"true"===this.dataset.shippingThreshold},this._drawer=document.querySelector(this._selectors.drawer),this._initAjaxCart()}fetch(e=!0){this.dispatchEvent(new CustomEvent(this._internalEvents.fetch,{detail:{openDrawer:e}}))}open(e=!0){this.dispatchEvent(new CustomEvent(this._internalEvents.open,{detail:{fetch:e}}))}close(){this.dispatchEvent(new CustomEvent(this._internalEvents.close))}refreshUpsell(){this.dispatchEvent(new CustomEvent(this._internalEvents.refreshUpsell))}_initAjaxCart(){var e=new URLSearchParams(window.location.search).get("viewcart");this._Ajaxcart=Vue.createApp(this._ajaxCartApp()),this._registerComponents(),this._Ajaxcart.mount("#AjaxCartTemplate"),this.classList.remove("hidden"),this._drawer.reinitWidget(),"true"===e&&this.open()}_ajaxCartApp(){const e=this;return{delimiters:["${","}"],data(){return{drawer:e._drawer,shippingThreshold:e._config.shippingThreshold,cart:null,error:!1,counter:document.querySelector(e._selectors.counter),cartHeight:!1,loading:{cart:!1,item:!1}}},computed:{handlesInCart(){return this.cart.items.reduce((e,t)=>({...e,[t.handle]:!0}),{})}},watch:{cart(){this.cartHeight||this.$nextTick(this.updateCartHeight)}},updated(){this.counter&&(this.cart||(this.counter.innerHTML=0),this.counter.innerHTML=this.cart.item_count,0!=this.counter.innerHTML?this.counter.classList.remove("hidden"):this.counter.classList.add("hidden"))},mounted(){var e=document.querySelector("s-ajaxcart");e.addEventListener("ajaxcart:fetch",this.onFetch),e.addEventListener("ajaxcart:open",this.onOpen),e.addEventListener("ajaxcart:close",this.onClose),document.addEventListener("CartDrawer:open",async()=>{this.cart||(this.cart=await this.fetchCart())}),document.addEventListener("CartDrawer:close",()=>{this.error&&(this.error=!1)}),document.addEventListener("cart:add:complete",this.onCartAddComplete),document.addEventListener("cart:update:complete",this.onCartUpdateComplete),document.addEventListener("cart:update:error",this.onCartError),document.addEventListener("cart:add:error",this.onCartError)},methods:{async fetchCart(){this.loading.cart=!0;var e=await theme.CartAPI.get();return this.loading.cart=!1,e},async updateItemQuantity({line:e,quantity:t}){t<0||(this.loading.item=e-1,e=await theme.CartAPI.change({line:e,quantity:t}),this.cart=e||await this.fetchCart(),this.loading.item=!1)},async removeItem(e){this.loading.item=e-1,await this.updateItemQuantity({line:e,quantity:0}),this.loading.item=!1},async addToCart({variantId:e,quantity:t}){this.loading.cart=!0;e=await theme.CartAPI.add({id:e,quantity:t});return this.loading.cart=!1,e},onCartUpdateComplete({detail:e}){e=e.cart;e?(this.cart=e,this.drawer.isOpen||this.drawer.open()):this.fetchCart().then(e=>{this.cart=e,this.drawer.isOpen||this.drawer.open()}).catch(e=>console.log(e))},onCartAddComplete(){this.fetchCart().then(e=>{this.cart=e,this.drawer.isOpen||this.drawer.open()}).catch(e=>console.log(e))},onFetch({detail:e}){const{openDrawer:t=!1}=e;this.fetchCart().then(e=>{this.cart=e,t&&this.drawer.open()}).catch(e=>console.log(e))},onOpen({detail:e}){var{fetch:e=!0}=e;e?this.fetchCart().then(e=>{this.cart=e,this.drawer.open()}).catch(e=>console.log(e)):this.drawer.open()},onClose(){this.drawer.close()},onCartError({detail:e}){e=e.error;e&&("unprocessable_entity"===e.status?this.error=e.message:this.error="We apologize, an error occured when updating your cart.")},formatMoney(e){return theme.utils.formatMoney(e)},updateCartHeight(){var e=this.$refs.cartHeader.clientHeight,t=this.$refs.cartFooter.clientHeight;this.cartHeight=`calc(100vh - ${(e+t)/16}rem)`}}}}_registerComponents(){var e=document.querySelector(this._selectors.upsellData),t=document.querySelector("#AjaxCartShippingThreshold").dataset.threshold;this._registerComponent("line-item","#AjaxCartLineItem",this._Components.LineItem()),this._registerComponent("shipping-threshold","#AjaxCartShippingThreshold",this._Components.ShippingThreshold(t)),this._registerComponent("gift-message","#AjaxCartGWPMessage",this._Components.GiftMessage()),this._registerComponent("upsell-products","#AjaxCartUpsell",this._Components.UpsellProducts(e?JSON.parse(e.innerHTML):[])),this._registerComponent("upsell-product","#AjaxCartUpsellProduct",this._Components.UpsellProduct()),this._registerComponent("skeleton-item","#AjaxCartSkeletonItem",this._Components.SkeletonItem())}_registerComponent(e,t,s){t=document.querySelector(t);this._Ajaxcart.component(e,{template:t.innerHTML,...s}),t.remove()}_Components={mixins(){return{methods:{formatMoney(e){return theme.utils.formatMoney(e)},truncateString(e,t,s="..."){return e.length<t?e:e.substring(0,t)+s},arrayIntoBooleanObject(e,s){return e.reduce((e,t)=>({...e,[s?t[s]:t]:!0}),{})}}}},LineItem(){return{delimiters:["${","}"],mixins:[this.mixins()],props:["item","line","loading"],emits:["removeItem","updateItemQuantity"],data(){return{title:""}},computed:{productTitle(){return this.item.product_title.split("-")[0]}}}},ShippingThreshold(e){return{delimiters:["${","}"],mixins:[this.mixins()],props:["cart"],data(){return{threshold:e}},computed:{amountForFreeShipping(){if(this.cart)return this.threshold-this.cart.total_price},progress(){if(this.cart)return this.cart.total_price/this.threshold*100},unlocked(){return this.amountForFreeShipping<=0}}}},GiftMessage(){return{delimiters:["${","}"],props:["cart"],data(){return{display:!1}},methods:{async validateGWP(){var e=await fetch(window.location.origin+"/?sections=gwp-data").then(e=>e.json()).then(e=>e["gwp-data"]).catch(e=>console.error("Failed to fetch GWP data section",e));if(e)try{var t=await e,s=(new DOMParser).parseFromString(t,"text/html").getElementById("gwpData"),r=(s?JSON.parse(s.innerHTML):null)?.gwpAllowed??!1;this.display=r}catch(e){console.error("There has been a problem validating cart GWP:",e),this.display=!1}else this.display=!1}},watch:{cart(){this.validateGWP()}},created(){this.validateGWP()}}},UpsellProducts(){const t={upsellData:"#AjaxCartUpsellData[js-upsell-data]",upsellDataB:"#AjaxCartUpsellDataB[js-upsell-data-b]"};return{delimiters:["${","}"],mixins:[this.mixins()],props:["cart","handlesInCart","variant","title"],emits:["addToCart"],data(){return{products:[],defaultProducts:[],taggedProducts:{},limit:theme.config.upsellLimit,upsellTags:theme.upsellTags||[],fetching:!1,currentSlide:0}},computed:{tagsInCart(){if(this.cart&&this.cart.items){let t=[];return this.cart.items.forEach(e=>{e&&e.properties&&e.properties._upsellTag&&t.push(e.properties._upsellTag)}),this.arrayIntoBooleanObject(t)}},handlesInUpsell(){return this.getHandles(this.products)}},created(){var e="b"===this.variant?t.upsellDataB:t.upsellData,e=document.querySelector(e);e&&(e=JSON.parse(e.innerHTML),console.log(e),this.processParsedProducts(e))},mounted(){document.querySelector("s-ajaxcart").addEventListener("ajaxcart:upsell:refresh",this.refreshUpsell),this.refreshUpsell()},watch:{cart(s,e){return!e||!s||e&&!e.items||s&&!s.items?this.refreshUpsell():void(e.items.some((e,t)=>e&&s&&s.items&&s.items[t]&&s.items[t].handle!==e.handle)&&this.refreshUpsell())}},updated(){setTimeout(()=>this.initSlider(),1)},methods:{initSlider(){var e=document.querySelector("[js-upsell-slider]");this.slider&&this.slider.destroy(!0,!0),e&&(this.slider=new Swiper(e,{slidesPerView:"auto",grabCursor:!0,centeredSlides:!1,autoHeight:!0}),this.slider.on("slideChange",e=>{this.currentSlide=e}),this.products.length)&&this.slider.slideTo(this.currentSlide)},async refreshUpsell(){if(this.cart&&this.cart.items)try{this.removeUpsellProductsInCart(),await this.fetchUpsell(),this.products.length<this.limit&&(this.fillUpsellWithTaggedProducts(),this.fillUpsellWithDefaults())}catch(e){console.log(e)}},async fetchUpsell(){this.products=(await this.fetchUpsellHandles(this.getUpsellHandles())).filter(e=>e.available)},processParsedProducts(e){e&&e.forEach(e=>{e.product&&e.tag&&e.product.available&&(e.product.options=e.product_options,"__DEFAULT__"===e.tag?this.defaultProducts.push(e.product):this.taggedProducts[e.tag]?this.taggedProducts[e.tag].push(e.product):this.taggedProducts[e.tag]=[e.product])})},fillUpsellWithTaggedProducts(){for(let e=0;e<this.upsellTags.length&&!(this.products.length>=this.limit);e++){var t=this.upsellTags[e];this.tagsInCart[t]&&this.taggedProducts[t]&&this.taggedProducts[t].forEach(e=>{this.products.length>=this.limit||this.addToUpsellIfNotRedundant(e)})}},fillUpsellWithDefaults(){for(let e=0;e<this.defaultProducts.length&&!(this.products.length>=this.limit);e++){var t=this.defaultProducts[e];this.handlesInUpsell[t.handle]||this.addToUpsellIfNotRedundant(t)}},async fetchUpsellHandles(e){if(!e&&!e.length)return Promise.resolve([]);let t=[];this.fetching=!0;try{t=await Promise.all(e.map(e=>fetch(`/products/${e}.js`))).then(e=>Promise.all(e.map(e=>e.json())))}catch(e){console.error(e)}finally{return this.fetching=!1,t}},getUpsellHandles(){if(this.cart&&this.cart.items){let t,s,r=0;var i=[];for(let e=0;e<this.cart.items.length&&!(r>this.limit);e++)t=this.cart.items[e],(s=t&&t.properties&&t._upsellHandle?t.properties._upsellHandle:s)&&!this.handlesInCart[s]&&(i.push(s),r++);return[...new Set(i)]}},removeUpsellProductsInCart(){let e=this.products.length;for(var t;e--;)t=this.products[e].handle,this.handlesInCart[t]&&this.products.splice(e,1)},addToUpsellIfNotRedundant(e){e&&e.handle&&(this.handlesInUpsell[e.handle]||this.handlesInCart[e.handle]||(this.products.push(e),this.handlesInUpsell[e.handle]=!0))},getHandles(e){return Array.isArray(e)?this.arrayIntoBooleanObject(e,"handle"):{}},changeSlide(e){this.currentSlide=e}}}},UpsellProduct(){return{delimiters:["${","}"],mixins:[this.mixins()],props:["product"],data(){return{selectedVariant:this.getFirstAvailableVariant(),options:{1:null,2:null,3:null}}},mounted(){this.options[1]=this.selectedVariant.option1,this.options[2]=this.selectedVariant.option2,this.options[3]=this.selectedVariant.option3},methods:{addToCart(){this.selectedVariant&&theme.CartAPI.add({id:this.selectedVariant.id,quantity:1,upsell:{tags:this.product.tags,handle:null}})},getFirstAvailableVariant(){if(!this.product)return null;let t;for(let e=0;e<this.product.variants.length;e++){var s=this.product.variants[e];if(s.available){t=s;break}}return t},onOptionChange(){this.selectedVariant=this.getVariantFromOptions(this.options)},getVariantFromOptions(i){let a=!1;return this.product.variants.forEach(e=>{let t=!0;for(const r in i){var s="option"+r;t=t&&i[r]===e[s]}t&&(a=e)}),a}}}},SkeletonItem(){return{}}}}class Carousel extends HTMLElement{constructor(){super(),this.selectors={carousel:"[js-carousel]"},this.options={loop:!0,slidesPerView:"auto",grabCursor:!0,centeredSlides:!1,navigation:!1,pagination:!1}}connectedCallback(){var e=this.dataset.options?JSON.parse(this.dataset.options):{};this.options=Object.assign(this.options,e),this._initCarousel()}_initCarousel(){if(null==this.querySelector(this.selectors.carousel))return!1;let e="#"+this.querySelector(this.selectors.carousel).id;void 0!==this.dataset.init?enquire.register(theme.config.mediaQueries[this.dataset.init],{match:function(){this.carousel=new Swiper(e,this.options)}.bind(this),unmatch:function(){this.carousel.el.classList.contains("swiper-initialized")&&this.carousel.destroy(!0,!0)}.bind(this)}):this.carousel=new Swiper(e,this.options)}}class SiteHeader extends HTMLElement{constructor(){super(),this._selectors={header:"#shopify-section-header",indexHeader:"[js-index-header]",promoBar:"[js-header-promo]",promoCloseBtn:"[js-header-promo-close]",mobileNavDrawer:"#MobileNavDrawer",megeMenu:"[js-mega-menu]",megaMenuGrandchildren:"[js-mega-menu-grandchildren]",megaMenuLogo:"[js-mega-menu-logo]",megaMenuTeams:"[js-mega-menu-teams]"}}connectedCallback(){this.header=document.querySelector(this._selectors.header),this.indexHeader=this.querySelector(this._selectors.indexHeader),this.promoBar=this.querySelector(this._selectors.promoBar),this.promoCloseBtn=this.querySelector(this._selectors.promoCloseBtn),this.megeMenus=this.querySelectorAll(this._selectors.megeMenu),this.megaMenuLogo=this.querySelectorAll(this._selectors.megaMenuLogo),this.megaMenuTeams=this.querySelectorAll(this._selectors.megaMenuTeams),this._setVariables(),this.promoBar&&this._initPromoBar(),this._adjustHeaderIndex(),this._adjustMegaMenuHeights(),this._setListeners(),this._openFirstLogo()}_setListeners(){this.promoCloseBtn&&this.promoCloseBtn.addEventListener("click",this._closePromoBar),this.indexHeader&&document.addEventListener("scroll",this._checkScroll),this.megaMenuLogo.forEach(e=>{e.addEventListener("mouseover",()=>this._showTeams(e))})}_setVariables(){document.documentElement.style.setProperty("--header-height",this.header.clientHeight+"px")}_initPromoBar(){sessionStorage.getItem("PromoBarClose")||(this.promoBar.classList.remove("hidden"),this._setVariables())}_closePromoBar=()=>{this.promoBar.classList.add("hidden"),sessionStorage.setItem("PromoBarClose",!0),this._setVariables()};_checkScroll=()=>{window.innerWidth<1025||(window.scrollY>this.offsetHeight?this.indexHeader.classList.remove("site-header__header--index"):this.indexHeader.classList.add("site-header__header--index"))};_adjustHeaderIndex(){var e=document.querySelector(this._selectors.mobileNavDrawer);if(!e)return;e.addEventListener("open",()=>{this.header.style.zIndex=60}),e.addEventListener("close",()=>{this.header.style.zIndex=5})}_adjustMegaMenuHeights(){this.megeMenus.forEach(e=>{var t=e.querySelectorAll(this._selectors.megaMenuGrandchildren);let s=0;t.forEach(e=>{s<e.clientHeight&&(s=e.clientHeight)}),e.clientHeight<s&&(e.style.height=s+"px")})}_openFirstLogo(){var e;0<this.megaMenuLogo.length&&((e=this.megaMenuLogo[0].closest(".by-league__site-header-nav__child-link-wrapper").querySelector("[js-mega-menu-teams]")).classList.remove("opacity-0","pointer-events-none","h-0"),e.classList.add("opacity-100","pointer-events-auto","h-auto"),e.closest(".by-league__site-header-nav__child-link-wrapper").querySelector("[js-mega-menu-logo]").classList.add("active-logo-bg"))}_showTeams(t){var e=t.closest(".by-league__site-header-nav__child-link-wrapper"),s=e.querySelector("[js-mega-menu-teams]"),e=e.querySelector("[js-mega-menu-logo]");this.megaMenuTeams.forEach(e=>{e!==t.closest(".by-league__site-header-nav__child-link-wrapper").querySelector("[js-mega-menu-teams]")&&(e.classList.add("opacity-0","pointer-events-none","h-0","js-no-hover"),e.classList.remove("opacity-100","pointer-events-auto","h-auto"),e.closest(".by-league__site-header-nav__child-link-wrapper").querySelector("[js-mega-menu-logo]").classList.remove("active-logo-bg"))}),s.classList.contains("opacity-0")?(s.classList.remove("opacity-0","pointer-events-none","h-0","js-no-hover"),s.classList.add("opacity-100","pointer-events-auto","h-auto"),e.classList.add("active-logo-bg")):(s.classList.remove("opacity-0","pointer-events-none","h-0","js-no-hover"),s.classList.remove("opacity-100","pointer-events-auto","h-auto"))}}class ProductOptions extends HTMLElement{constructor(){super(),this._selectors={singleOptionSelector:"[js-product-option-selector]"},this._events={change:"variant:change",fetchBefore:"variant:fetch:before",fetchAfter:"variant:fetch:after",fetchError:"variant:fetch:error"}}connectedCallback(){var e;this._handle=this.dataset.productHandle,this._masterSelect=document.getElementById(this.dataset.masterSelectId),this._checkAvailableOptions=!this.hasAttribute("data-disable-option-binding"),this._optionSelectors=[...this.querySelectorAll(this._selectors.singleOptionSelector)],this._checkAvailableOptions&&(this._availableValues={},this._lastSelectedOption=null,this._option1Values=this._option2Values=null),this.dataset.product&&(e=document.getElementById(this.dataset.product))&&(this._product=JSON.parse(e.innerHTML)),this._product&&(this._currentVariant=this._getVariantFromOptions(),this._checkAvailableOptions)&&this._setupOptionsAvailability(this._product),(this._product||this._handle)&&this._setupListeners()}set product(e){this._product=e,this.disconnectedCallback(),this.connectedCallback()}_setupListeners(){this._optionSelectors.forEach(e=>e.addEventListener("change",this._handleOptionChange))}_getVariantFromOptions(){if(this._product){const s=this._getCurrentOptions();var e=this._product["variants"];return e.find(t=>s.every(e=>e.value===t[e.index].toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-$/,"").replace(/^-/,"")))}}_getCurrentOptions(){return this._optionSelectors.map(e=>{var t=e.getAttribute("type"),s={};return("radio"!==t&&"checkbox"!==t||!!e.checked)&&(s.value=e.value,s.index=e.dataset.index,s)}).filter(e=>e)}_setupOptionsAvailability(e){this._option1Values=new Set,this._option2Values=new Set,e.variants.forEach(e=>{var{option1:e,option2:t}=e;e&&this._option1Values.add(e.toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-$/,"").replace(/^-/,"")),t&&this._option2Values.add(t.toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-$/,"").replace(/^-/,""))}),this._option1Values=[...this._option1Values],this._option2Values=[...this._option2Values],this._optionSelectors.forEach(e=>{null==this._lastSelectedOption&&e.checked&&(this._lastSelectedOption={key:e.dataset.index,value:e.value})}),this._availableValues=this._getAvailableValues(this._product,this._lastSelectedOption),this._refreshValuesUI(this._availableValues)}_handleOptionChange=t=>{this._product?this._updateVariant(t):this._fetchProduct(this._handle).then(e=>{this._product=e,this._checkAvailableOptions&&this._setupOptionsAvailability(this._product),this._updateVariant(t)}).catch(e=>console.log(e))};_updateVariant(e){this._lastSelectedOption={key:e.target.dataset.index,value:e.target.value};var t,s,e=this._getVariantFromOptions();this.dispatchEvent(new CustomEvent(this._events.change,{detail:{variant:e,priceChange:this._hasPriceChanged(e)},bubbles:!0})),this._checkAvailableOptions&&(t=this._getAvailableValues(this._product,this._lastSelectedOption),s=this._getDifference(this._availableValues,t),this._refreshValuesUI(s),this._availableValues=t),this.hasAttribute("data-enable-history-state")&&this._updateHistoryState(e),this._masterSelect&&this._updateMasterSelect(e),this._currentVariant=e}_hasPriceChanged(e){return!(!e||!this._currentVariant||e.price===this._currentVariant.price&&e.compare_at_price===this._currentVariant.compare_at_price)}_getAvailableValues(e,t){return e.variants.reduce((e,t)=>{var{option1:t,option2:s}=t;return t&&(e[t]=!0),s&&(e[s]=!0),e},{})}_refreshValuesUI(e){for(const s in e){var t=this.querySelector(`[value="${s}"]`);t&&(t.disabled=!e[s])}}_updateHistoryState(e){history.replaceState&&e&&(e=window.location.protocol+"//"+window.location.host+window.location.pathname+"?variant="+e.id,window.history.replaceState({path:e},"",e))}_updateMasterSelect(e){e&&(this._masterSelect.value=e.id)}async _fetchProduct(e){this.dispatchEvent(new CustomEvent(this._events.fetchBefore,{bubbles:!0}));try{var t=await(await fetch(`/products/${e}.js`)).json();return this.dispatchEvent(new CustomEvent(this._events.fetchAfter,{bubbles:!0})),t}catch(e){this.dispatchEvent(new CustomEvent(this._events.fetchError,{details:{error:e},bubbles:!0}))}}_getDifference(e,t){var s={};if(e||t){if(!e)return t;if(!t)return e;for(const r in t)t[r]!==e[r]&&(s[r]=t[r])}return s}disconnectedCallback(){this._optionSelectors.forEach(e=>e.removeEventListener("change",this._handleOptionChange))}}class QuantityInput extends HTMLElement{constructor(){super(),this.input=this.querySelector("input"),this.changeEvent=new Event("change",{bubbles:!0}),this.querySelectorAll("button").forEach(e=>e.addEventListener("click",this.onButtonClick.bind(this)))}onButtonClick(e){e.preventDefault();var t=this.input.value;"plus"===e.target.name?this.input.stepUp():this.input.stepDown(),t!==this.input.value&&this.input.dispatchEvent(this.changeEvent)}}class LoadingSpinner extends HTMLElement{constructor(){super();var e=document.createElement("template");e.innerHTML=`
    <style>
      :host {
        display: none;
        position: absolute;        
        top: 0; right: 0; bottom: 0; left: 0;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
      }

      :host([loading]) {
        display: flex;
      }

      .background {
        position: absolute;        
        top: 0; right: 0; bottom: 0; left: 0;
        width: 100%;
        height: 100%;
        background: var(--background, 'transparent');
        opacity: var(--bg-opacity, 50%);
        z-index: 1;
      }

      .loading-spinner {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        width: var(--width, 20px);
        height: var(--height, 20px);
        color: var(--color, black);
        z-index: 2;
        animation: loading-spinner 1s linear infinite;
      }

      .loading-spinner svg{
        fill: currentColor;
        width: 100%;
      }

      @keyframes loading-spinner {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    </style>

    <div class="background"></div>
    <div class="loading-spinner">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 145 145">
        <path d="M72.5,145C32.6,145,.07,112.54,0,72.64H5c.07,37.14,30.35,67.36,67.5,67.36s67.5-30.28,67.5-67.5S109.72,5,72.5,5V0c39.98,0,72.5,32.52,72.5,72.5s-32.52,72.5-72.5,72.5Z" />
      </svg>
    </div>
    `,this.attachShadow({mode:"open"}),this.shadowRoot.appendChild(e.content.cloneNode(!0))}}class PredictiveSearch extends HTMLElement{constructor(){super(),this.searchDrawer=document.querySelector("#SearchDrawer"),this.input=this.querySelector('input[type="search"]'),this.form=this.querySelector("[js-predictive-search-form]"),this.predictiveSearchResults=this.querySelector("[js-predictive-search-results]"),this.predictiveSearchSuggestions=this.querySelector("[js-predictive-search-suggestions]"),this.predictiveSearchProducts=this.querySelector("[js-predictive-search-products]"),this.predictiveSearchViewAll=this.querySelector("[js-predictive-search-view-all]"),this.predictiveSearchNoResults=this.querySelector("[js-predictive-search-no-results]"),this.predictiveSearchClearBtn=this.querySelector("[js-predictive-search-clear]"),this.query="",this.searchDrawer.addEventListener("open",()=>this.input.focus()),this.input.addEventListener("input",theme.utils.debounce(e=>{this.onChange(e)},300).bind(this)),this.predictiveSearchClearBtn.addEventListener("click",this.clearPredictiveSearch),this.form.addEventListener("submit",this.onSubmit),this.predictiveSearchResults.addEventListener("scrollend",this.loadMoreResults),this.pageOffset=1,this.totalPages=1}onSubmit=e=>{e.preventDefault(),window.location.href="/search?query="+(this.query?""+this.query:""+this.input.value)};clearPredictiveSearch=e=>{e.preventDefault(),this.input.value="";e=new Event("input",{bubbles:!0,cancelable:!0});this.input.dispatchEvent(e)};onChange(){this.query=this.input.value;var e=this.input.value.trim();e.length?(this.getSearchSuggestions(e),this.predictiveSearchClearBtn.classList.remove("hidden")):(this.close(),this.predictiveSearchClearBtn.classList.add("hidden"))}suggestionTrigger(){const t=this.predictiveSearchSuggestions.querySelectorAll("[js-predictive-search-suggestion]");t.forEach(e=>{e.addEventListener("click",e=>{e.preventDefault(),this.getSearchProducts(e.currentTarget.dataset.originalText,e.currentTarget.dataset.suggestionText),t.forEach(e=>{e.classList.remove("underline")}),e.currentTarget.classList.add("underline")})})}getSearchProducts(e,s){fetch(`https://cui8ns.a.searchspring.io/api/search/autocomplete.json?siteId=cui8ns&resultsFormat=json&q=${s}&oq=${e}&redirectResponse=full&page=1&resultsPerPage=24&bgfilter.is_published=yes`,{method:"GET",headers:{accept:"application/json"}}).then(e=>e.json()).then(e=>{let a=this.predictiveSearchProducts.innerHTML="";var t=e.results;t&&(this.query=s,t.forEach(e=>{var t;let s="",r=e.name,i="";e.mfield_data_product_prefix&&(s=`<div class="font-400">${e.mfield_data_product_prefix}</div>`),e.name.includes("New Era 59Fifty")?r=r.replace("New Era 59Fifty","").trim():e.name.includes("Exclusive New Era 59Fifty")?r=r.replace("Exclusive New Era 59Fifty","").trim():e.name.includes("New Era 9Fifty")?r=r.replace("New Era 9Fifty","").trim():e.name.includes("New Era 9Forty")?r=r.replace("New Era 9Forty","").trim():e.name.includes("47 Brand")&&(r=r.replace("47 Brand","").trim()),r.includes(" - ")&&(i=`<div class="font-700">${r.split(" - ")[1]}</div>`,r=r.split(" - ")[0]),t=`${s}<div class="font-700">${r}</div>`+i,a=`${a}
              <li class="predictive-search__product-wrapper">
                <a href="${e.url}" class="predictive-search__product h-full flex flex-col justify-between link">
                  <img src="${e.imageUrl}" loading="lazy" alt="${e.name}" class="predictive-search__product-image block w-full desktop:px-32" />
                  <div class="predictive-search__product-title w-full text-small uppercase tabletp:text-14 tabletp:leading-[21px] desktop:pt-16">${t}</div>
                </a>
              </li>
            `}),this.predictiveSearchProducts.insertAdjacentHTML("beforeend",a),this.predictiveSearchViewAll.innerHTML=`${0!=e.pagination.totalResults?"VIEW ALL ":""} ${e.pagination.totalResults} Product(s) For "${s}"`,this.totalPages=e.pagination.totalPages)}).catch(e=>console.error(e))}getSearchSuggestions(e){fetch(`https://cui8ns.a.searchspring.io/api/suggest/query?siteId=cui8ns&q=${e}&language=en&suggestionCount=6&productCount=30`,{method:"GET",headers:{accept:"application/json"}}).then(e=>e.json()).then(r=>{if(this.predictiveSearchSuggestions.innerHTML="",this.predictiveSearchProducts.innerHTML="",r.suggested){let t="";const i=r.query,a=`<b class="text-black">${r.query}</b>`;let s=r.suggested.text.replace(i,a);t=`${t}
              <li class="predictive-search__suggestion-wrapper pt-16 desktop:pt-8">
                <a class="predictive-search__suggestion h2 text-gray-true underline" href="/search?query=${encodeURIComponent(r.query)}" data-original-text="${r.query}" data-suggestion-text="${r.suggested.text}">${s}</a>
              </li>
            `,r.alternatives.forEach(e=>{s=e.text.replace(i,a),t=`${t}
              <li class="predictive-search__suggestion-wrapper pt-16 desktop:pt-8">
                <a class="predictive-search__suggestion h2 text-gray-true" href="/search?query=${encodeURIComponent(e.text)}" data-original-text="${r.query}" data-suggestion-text="${e.text}">${s}</a>
              </li>
            `}),this.predictiveSearchSuggestions.insertAdjacentHTML("beforeend",t),this.getSearchProducts(r.query,r.suggested.text),this.suggestionTrigger(),this.predictiveSearchSuggestions.classList.remove("hidden"),this.predictiveSearchProducts.classList.remove("hidden"),this.predictiveSearchViewAll.classList.remove("hidden"),this.predictiveSearchNoResults.classList.add("hidden")}else this.predictiveSearchSuggestions.classList.add("hidden"),this.predictiveSearchProducts.classList.add("hidden"),this.predictiveSearchViewAll.classList.add("hidden"),this.predictiveSearchNoResults.classList.remove("hidden");this.open()}).catch(e=>{console.error(e),this.close()})}loadMoreResults=e=>{e.preventDefault();if(this.input.value&&!(this.totalPages<this.pageOffset)){this.pageOffset++;const s=this.input.value;e=this.input.value;fetch(`https://cui8ns.a.searchspring.io/api/search/autocomplete.json?siteId=cui8ns&resultsFormat=json&q=${s}&oq=${e}&redirectResponse=full&page=${this.pageOffset}&resultsPerPage=24&bgfilter.is_published=yes`,{method:"GET",headers:{accept:"application/json"}}).then(e=>e.json()).then(e=>{let a="";var t=e.results;t&&(this.query=s,t.forEach(e=>{var t;let s="",r=e.name,i="";e.mfield_data_product_prefix&&(s=`<div class="font-400">${e.mfield_data_product_prefix}</div>`),e.name.includes("New Era 59Fifty")?r=r.replace("New Era 59Fifty","").trim():e.name.includes("Exclusive New Era 59Fifty")?r=r.replace("Exclusive New Era 59Fifty","").trim():e.name.includes("New Era 9Fifty")?r=r.replace("New Era 9Fifty","").trim():e.name.includes("New Era 9Forty")?r=r.replace("New Era 9Forty","").trim():e.name.includes("47 Brand")&&(r=r.replace("47 Brand","").trim()),r.includes(" - ")&&(i=`<div class="font-700">${r.split(" - ")[1]}</div>`,r=r.split(" - ")[0]),t=`${s}<div class="font-700">${r}</div>`+i,e.imageUrl&&(a=`${a}
                <li class="predictive-search__product-wrapper">
                  <a href="${e.url}" class="predictive-search__product h-full flex flex-col justify-between link">
                    <img src="${e.imageUrl}" loading="lazy" alt="${e.name}" class="predictive-search__product-image block w-full desktop:px-32" />
                    <div class="predictive-search__product-title w-full text-small uppercase tabletp:text-14 tabletp:leading-[21px] desktop:pt-16">${t}</div>
                  </a>
                </li>
              `)}),this.predictiveSearchProducts.insertAdjacentHTML("beforeend",a),this.predictiveSearchViewAll.innerHTML=`${0!=e.pagination.totalResults?"VIEW ALL ":""} ${e.pagination.totalResults} Product(s) For "${s}"`)}).catch(e=>console.error(e))}};open(){this.predictiveSearchResults.style.display="block",document.body.classList.add("overflow-hidden")}close(){this.predictiveSearchResults.style.display="none",document.body.classList.remove("overflow-hidden")}}class FilterSort extends HTMLElement{constructor(){super(),this._selectors={container:"filter-sort",form:"[js-filter-form]",filter:"[js-filter]",clearAll:"[js-clear-all]",loader:"loading-spinner"},this._events={change:"filter:change"},this._refresh=["[js-filter]","[js-sort]","[js-total-active-values]","[js-filter-results-count]"],this._cache=[],this._debouncedOnSubmit=theme.utils.debounce(e=>{this._onSubmitHandler(e)},500)}connectedCallback(){this._form=this.querySelector(this._selectors.form),this._clearAll=this.querySelector(this._selectors.clearAll),this._loader=this.querySelector(this._selectors.loader),this._setListeners()}_setListeners(){window.addEventListener("popstate",this._onHistoryChange),this._form.addEventListener("input",this._debouncedOnSubmit),this._clearAll.addEventListener("click",this._onClearAllHandler),document.addEventListener("filter:clearAll",this._onClearAllHandler)}_renderComponent(e){e=e.querySelector(this._selectors.container);theme.utils.refreshElements(this._refresh,e,this)}_onSubmitHandler=e=>{e.preventDefault();e=new FormData(this._form),e=new URLSearchParams(e).toString();this._propagateChange(e)};_onClearAllHandler=e=>{e.preventDefault();this._propagateChange("")};_onHistoryChange=e=>{e=e.state?e.state.searchParams:FilterSort.searchParamsInitial;e!==FilterSort.searchParamsPrev&&(this._propagateChange(e,!1),this._onSubmitHandlerEvent=null)};async _propagateChange(e,t=!0){this._loader.setAttribute("loading","");let s=!0;const r=window.location.pathname+"?"+e;var i=e=>e.url===r,i=this._cache.some(i)?this._markupFromCache(i):await this._markupFromFetch(r);e&&(s=!1),document.dispatchEvent(new CustomEvent("filter:change",{detail:{parsedHTML:i,clearClicked:s}})),this._renderComponent(i),this.querySelector("s-accordion").connectedCallback(),t&&history.pushState({searchParams:e},"",""+window.location.pathname+(e&&"?".concat(e))),this._loader.removeAttribute("loading")}_markupFromCache(e){e=this._cache.find(e).html;return(new DOMParser).parseFromString(e,"text/html")}_markupFromFetch(s){let r=this._cache;return fetch(s).then(e=>e.text()).then(e=>{var t=(new DOMParser).parseFromString(e,"text/html");return r=[...r,{html:e,url:s}],t})}}FilterSort.searchParamsInitial=window.location.search.slice(1),FilterSort.searchParamsPrev=window.location.search.slice(1);class ActiveFilters extends HTMLElement{constructor(){super(),this._selectors={remove:"[js-remove]",clearAll:"[js-clear-all]"},this._refresh=["[js-active-filter]"]}connectedCallback(){document.addEventListener("filter:change",this._handleFilterChange),this._setListeners()}_setListeners(){var e=this.querySelector(this._selectors.clearAll);e&&e.addEventListener("click",this._triggerClearAll),this.querySelectorAll(this._selectors.remove).forEach(e=>e.addEventListener("click",this._handleRemove))}_handleRemove=e=>{e.preventDefault();var{name:e,value:t}=e.currentTarget.dataset,e=document.querySelector(`filter-sort [name="${e}"][value="${t}"]`);e&&e.click()};_handleFilterChange=e=>{e=e.detail.parsedHTML,e=e.querySelector("active-filters");this.innerHTML=e.innerHTML,this._setListeners()};_triggerClearAll=e=>{e.preventDefault(),e.stopImmediatePropagation(),document.dispatchEvent(new CustomEvent("filter:clearAll"))}}class PriceRange extends HTMLElement{constructor(){super(),this.querySelectorAll("input").forEach(e=>e.addEventListener("change",this.onRangeChange.bind(this))),this.setMinAndMaxValues()}onRangeChange(e){this.adjustToValidValues(e.currentTarget),this.setMinAndMaxValues()}setMinAndMaxValues(){var e=this.querySelectorAll("input"),t=e[0],e=e[1];e.value&&t.setAttribute("max",e.value),t.value&&e.setAttribute("min",t.value),""===t.value&&e.setAttribute("min",0),""===e.value&&t.setAttribute("max",e.getAttribute("max"))}adjustToValidValues(e){var t=Number(e.value),s=Number(e.getAttribute("min")),r=Number(e.getAttribute("max"));t<s&&(e.value=s),r<t&&(e.value=r)}}class ProductCard extends HTMLElement{constructor(){super(),this._selectors={quickAddTrigger:"[js-quick-add-trigger]",quickAddCopy:"[js-quick-add-copy]",mobileQuickAddDrawer:"#MobileQuickAddDrawer",mobileQuickAdd:"[js-mobile-quick-add]",wishlist:"[js-product-card-wishlist]",productLink:"[js-product-link]"}}connectedCallback(){this.quickAddTriggers=this.querySelectorAll(this._selectors.quickAddTrigger),this.quickAddCopy=this.querySelector(this._selectors.quickAddCopy),this.mobileQuickAddDrawer=document.querySelector(this._selectors.mobileQuickAddDrawer),this.mobileQuickAdd=this.mobileQuickAddDrawer.querySelector(this._selectors.mobileQuickAdd),this.wishlist=this.querySelector(this._selectors.wishlist),this.productLinks=this.querySelectorAll(this._selectors.productLink),this._setListeners(),0<this.productLinks.length&&this._saveProductBreadcrumb()}_setListeners(){this.quickAddTriggers.forEach(e=>{e.addEventListener("click",this._toggleQuickAdd)}),this.wishlist.addEventListener("click",this._removeFromWishlist)}_saveProductBreadcrumb=()=>{this.productLinks.forEach(t=>{t.addEventListener("click",e=>{e.preventDefault();var e=this.closest("searchspring-results");e.hasAttribute("data-collection-url")&&(e={collectionUrl:e.dataset.collectionUrl,collectionTitle:e.dataset.collectionTitle},sessionStorage.setItem("productBreadcrumb",JSON.stringify(e))),location.href=t.href})})};_removeFromWishlist=e=>{const s=e.currentTarget;if(window._swat&&s.classList.contains("swym-added")){let t={epi:parseInt(s.dataset.variantId),empi:parseInt(s.dataset.productId),du:s.dataset.productUrl};window._swat.removeFromWishList(t,function(e){s.classList.remove("disabled","swym-added","swym-adding")},function(e){console.log("there was an error while removing the product from wishlist",e,t)})}};_closeQuickAddCopy=e=>{window.innerWidth<768?(this.mobileQuickAdd.innerHTML="",this.quickAddTriggers.forEach(e=>{e.classList.contains("product-card__quick-add-trigger-mobile")&&e.classList.remove("hidden")}),this.dataset.quickAddOpen="false",this.mobileQuickAddDrawer.removeEventListener("close",this._closeQuickAddCopy)):this.contains(e.target)||(e.preventDefault(),this.dataset.quickAddOpen="false",document.removeEventListener("click",this._closeQuickAddCopy))};_toggleQuickAdd=e=>{e.stopPropagation();var t,e=e.currentTarget;e.classList.toggle("rotate"),"false"==this.dataset.quickAddOpen?(document.querySelectorAll('[data-quick-add-open="true"]').forEach(e=>{e.dataset.quickAddOpen="false"}),this.dataset.quickAddOpen="true",window.innerWidth<768?(this.mobileQuickAdd.innerHTML="",t=this.quickAddCopy.cloneNode(!0),this.mobileQuickAdd.append(t),this.mobileQuickAddDrawer.open(),e.classList.add("hidden"),this.mobileQuickAddDrawer.addEventListener("close",this._closeQuickAddCopy)):document.addEventListener("click",this._closeQuickAddCopy)):this.dataset.quickAddOpen="false"}}class QuickAdd extends HTMLElement{constructor(){super(),this._selectors={quickAddAtc:"[js-quick-add-atc]",quickAddVariant:"[js-quick-add-variant]"}}connectedCallback(){this.quickAddAtc=this.querySelector(this._selectors.quickAddAtc),this.quickAddVariants=this.querySelectorAll(this._selectors.quickAddVariant),this._setListeners()}_setListeners(){this.quickAddAtc&&this.quickAddAtc.addEventListener("click",this._addToCart),this.quickAddVariants&&this.quickAddVariants.forEach(e=>{e.addEventListener("click",this._handleVariantChange)})}_addToCart=e=>{e.stopImmediatePropagation(),e.preventDefault();var e={items:[{id:e.currentTarget.dataset.id,quantity:1,properties:{}}]},t=this.getAttribute("data-upsell");t&&(e.items[0].properties._upsellTag=t),theme.CartAPI.add(e).then(()=>{768<=window.innerWidth&&(this.closest("product-card").dataset.quickAddOpen="false")}).catch(e=>{console.log(e)})};_updateAddToCartState(e){this.quickAddAtc.dataset.id=e,this.quickAddAtc.removeAttribute("disabled"),this.quickAddAtc.textContent="ADD TO CART"}_handleVariantChange=e=>{e=e.currentTarget.dataset.variantId;e&&this._updateAddToCartState(e)}}class Timer extends HTMLElement{constructor(){super(),this._selectors={timer:"[js-ea-timer]",timerContainer:"[js-ea-timer-container]"}}connectedCallback(){this._countdownTimer()}_setListeners(){}_countdownTimer(){dayjs.extend(window.dayjs_plugin_utc),dayjs.extend(window.dayjs_plugin_timezone),dayjs.extend(window.dayjs_plugin_duration),this.querySelectorAll(this._selectors.timerContainer).forEach(l=>{var c,e=l.querySelector(this._selectors.timer),t=e.getAttribute("data-ea-timer"),d=e.getAttribute("data-timer-type"),t=new Date(t),h=(console.log("timerType",d),dayjs.tz(t,"YYYY-MM-DD HH:mm","America/Phoenix"));dayjs().tz("America/Phoenix").isAfter(h)?l.querySelector("#early-access-timer").innerHTML="":c=setInterval(function(){var e,t=dayjs().tz("America/Phoenix"),s="",t=dayjs.duration(h.diff(t)),r=t.$d.days,i=t.$d.hours,a=t.$d.minutes,o=t.$d.seconds,n=`<div class="flex flex-col items-center justify-center"><div class="countdown-number">${r}</div><div class="countdown-number-value">DAYS</div></div>`+` ${`<div class="flex flex-col items-center justify-center"><div class="countdown-number">${i}</div><div class="countdown-number-value">HOURS</div></div>`} ${`<div class="flex flex-col items-center justify-center"><div class="countdown-number">${a}</div><div class="countdown-number-value">MINUTES</div></div>`} `+`<div class="flex flex-col items-center justify-center"><div class="countdown-number">${o}</div><div class="countdown-number-value">SECONDS</div></div>`;e=r+"D "+i+"H "+a+"M "+o+"S ",s=r<10?s+"0"+r+"D : ":s+r+"D : ",s=i<10?s+"0"+i+"H : ":s+i+"H : ",s=a<10?s+"0"+a+"M : ":s+a+"M : ",s=o<10?s+"0"+o+"S ":s+o+"S ",l.querySelector("#early-access-timer").innerHTML=d?"type_1"==d?e:"type_2"!=d&&"type_3"==d?n:s:s,t<0&&(clearInterval(c),l.querySelector("#early-access-timer").innerHTML="Please refresh your page")},1e3)})}}class LocalizationForm extends HTMLElement{constructor(){super(),this.elements={input:this.querySelector('input[name="language_code"], input[name="country_code"]'),button:this.querySelector("button"),panel:this.querySelector("ul")},this.elements.button.addEventListener("click",this.openSelector.bind(this)),this.elements.button.addEventListener("focusout",this.closeSelector.bind(this)),this.addEventListener("keyup",this.onContainerKeyUp.bind(this)),this.querySelectorAll("a").forEach(e=>e.addEventListener("click",this.onItemClick.bind(this)))}hidePanel(){this.elements.button.setAttribute("aria-expanded","false"),this.elements.panel.setAttribute("hidden",!0)}onContainerKeyUp(e){"ESCAPE"===e.code.toUpperCase()&&(this.hidePanel(),this.elements.button.focus())}onItemClick(e){e.preventDefault();var t=this.querySelector("form");this.elements.input.value=e.currentTarget.dataset.value,new FormData(t);console.log(this.elements.input.value)}openSelector(){this.elements.button.focus(),this.elements.panel.toggleAttribute("hidden"),this.elements.button.setAttribute("aria-expanded",("false"===this.elements.button.getAttribute("aria-expanded")).toString())}closeSelector(e){var t=e.relatedTarget&&"BUTTON"===e.relatedTarget.nodeName;null!==e.relatedTarget&&!t||this.hidePanel()}}class AppBanner extends HTMLElement{constructor(){super(),this._selectors={closeButton:"[js-close-button]",bannerLink:"[js-banner-link]"}}connectedCallback(){this.querySelector(this._selectors.closeButton).addEventListener("click",this._onCloseClick);var e=this.getMobileOperatingSystem(),t=e.toLowerCase()+"_banner_cookie",t=this.checkACookieExists(t);"iOS"!==e&&"Android"!==e||t||(this.updateBannerLink(e),this.classList.remove("hidden"))}getMobileOperatingSystem(){var e=navigator.userAgent;return/iPad|iPhone|iPod/.test(e)&&!window.MSStream?"iOS":/android/i.test(e)?"Android":"other"}updateBannerLink(e){var t=this.querySelector(this._selectors.bannerLink);"iOS"===e?t.href=this.getAttribute("data-ios-url"):"Android"===e&&(t.href=this.getAttribute("data-android-url"))}_onCloseClick=()=>{var e=this.getMobileOperatingSystem().toLowerCase();this.createCookie(e+"_banner_cookie","hidden",7),this.classList.add("hidden")};createCookie(e,t,s){var r=new Date;r.setDate(r.getDate()+s),document.cookie=`${e}=${t}; expires=${r.toUTCString()}; path=/`}checkACookieExists(t){return document.cookie.split(";").some(e=>e.trim().startsWith(t+"="))}}class HeroHotspots extends HTMLElement{constructor(){super(),this._selectors={hotspot:"[js-hero-hotspot]",trigger:"[js-hero-hotspot-trigger]"}}connectedCallback(){this._setListeners()}_setListeners=()=>{this.addEventListener("click",this._onTriggerClick)};_onTriggerClick=e=>{var t=e.target.closest(this._selectors.trigger);t&&(t=t.closest(this._selectors.hotspot))&&(e.preventDefault(),e.stopPropagation(),this._toggleHotspot(t))};_toggleHotspot=e=>{e.classList.contains("is-active")?this._closeHotspot(e):this._openHotspot(e)};_openHotspot=e=>{e.classList.add("is-active"),e.setAttribute("aria-expanded","true");e=e.querySelector(this._selectors.trigger);e&&e.setAttribute("aria-expanded","true")};_closeHotspot=e=>{e.classList.remove("is-active"),e.setAttribute("aria-expanded","false");e=e.querySelector(this._selectors.trigger);e&&e.setAttribute("aria-expanded","false")}}customElements.define("s-drawer",Drawer),customElements.define("s-modal",Modal),customElements.define("s-accordion",Accordion),customElements.define("s-tabs",Tabs),customElements.define("s-ajaxcart",AjaxCart),customElements.define("s-carousel",Carousel),customElements.define("s-header",SiteHeader),customElements.define("product-options",ProductOptions),customElements.define("quantity-input",QuantityInput),customElements.define("loading-spinner",LoadingSpinner),customElements.define("predictive-search",PredictiveSearch),customElements.define("filter-sort",FilterSort),customElements.define("active-filters",ActiveFilters),customElements.define("price-range",PriceRange),customElements.define("product-card",ProductCard),customElements.define("quick-add",QuickAdd),customElements.define("s-timer",Timer),customElements.define("localization-form",LocalizationForm),customElements.define("app-banner",AppBanner),customElements.define("hero-hotspots",HeroHotspots);class CollectionGrid extends HTMLElement{constructor(){super(),this._selectors={productGrid:"[js-products-grid]",toggleGrid:"[js-toggle-grid]",nextPageBtn:"[js-collection-next-page]",sortTrigger:"[js-sort-trigger]",sortTriggerLabel:"[js-sort-trigger-label]",loader:"loading-spinner",teamTrigger:"[js-team-trigger]",dummySizeInput:"[js-dummy-size-input]",filters:"[js-filter-form]"},this._refresh=["[js-products-grid]","[js-collection-pagination]","[js-sort-trigger]"],this._cache=[]}connectedCallback(){this.productGrid=this.querySelector(this._selectors.productGrid),this.toggleGrid=this.querySelectorAll(this._selectors.toggleGrid),this.nextPageBtn=this.querySelector(this._selectors.nextPageBtn),this.sortTrigger=this.querySelector(this._selectors.sortTrigger),this.sortTriggerLabel=this.querySelector(this._selectors.sortTriggerLabel),this.loader=this.querySelector(this._selectors.loader),this.teamTrigger=this.querySelector(this._selectors.teamTrigger),this.dummySizeInputs=document.querySelectorAll(this._selectors.dummySizeInput),this.filtersContainer=document.querySelector(this._selectors.filters),this._retainHistory(),this._setListeners(),this.teamTrigger&&this._handleTeamTrigger()}_setListeners(){document.addEventListener("filter:change",this._handleFilterChange),this.toggleGrid.forEach(e=>{e.addEventListener("click",this._updateGridView)}),this.nextPageBtn&&this.nextPageBtn.addEventListener("click",this._loadNextPage),this.sortTrigger&&this.sortTrigger.addEventListener("change",this._handleSortTrigger),this.dummySizeInputs&&this.dummySizeInputs.forEach(e=>{e.addEventListener("change",this._triggerDummyClick.bind(this))})}_handleTeamTrigger=()=>{this._refresh.includes("[js-team-trigger]","[js-team-trigger-label]")||this._refresh.push("[js-team-trigger]","[js-team-trigger-label]"),this.teamTrigger.addEventListener("change",e=>{e.preventDefault();var t=document.querySelector("[js-filter-form]"),s=t.querySelector("#TeamFilter"),r=new Event("input",{bubbles:!0,cancelable:!0});s.value=e.target.value,t.dispatchEvent(r)})};_handleSortTrigger=e=>{e.preventDefault();var t=document.querySelector("[js-filter-form]"),s=t.querySelector("#SortBy"),r=new Event("input",{bubbles:!0,cancelable:!0}),s=(s.value=e.target.value,t.dispatchEvent(r),e.currentTarget.options.selectedIndex),t=e.currentTarget.options[s].text;this.sortTriggerLabel.textContent=t};_retainHistory(){this.isFilterChanged||history.state&&(history.state.products&&(this.productGrid.innerHTML=history.state.products),history.state.view)&&(this.productGrid.setAttribute("data-view",history.state.view),this.toggleGrid.forEach(e=>{e.removeAttribute("disabled")}),this.querySelector(`[js-toggle-grid][data-view=${history.state.view}]`).setAttribute("disabled","disabled"))}_updateHistory(e,t,s){let r={};(r=history.state?history.state:r)[e]=t,s?history.pushState(r,"",s):history.pushState(r,"")}_getProducts(e){return fetch(e).then(e=>e.text()).then(e=>{return(new DOMParser).parseFromString(e,"text/html")})}_loadNextPage=async()=>{this.loader.setAttribute("loading","");var e=this.querySelector(this._selectors.nextPageBtn),t=e.dataset.url,s=await this._getProducts(t),r=s.querySelector(this._selectors.productGrid).innerHTML,s=s.querySelector(this._selectors.nextPageBtn);this.productGrid.insertAdjacentHTML("beforeend",r),document.dispatchEvent(new CustomEvent("swym:collections-loaded")),this._updateHistory("products",this.productGrid.innerHTML,t),s?e.setAttribute("data-url",s.dataset.url):e.remove(),this.loader.removeAttribute("loading")};_updateGridView=e=>{e.preventDefault();var e=e.currentTarget,t=e.dataset.view;this.toggleGrid.forEach(e=>{e.removeAttribute("disabled")}),e.setAttribute("disabled","disabled"),this.productGrid.setAttribute("data-view",t),this._updateHistory("view",t)};_handleFilterChange=e=>{var t=e.detail["parsedHTML"],t=t.querySelector(`[data-id="${this.dataset.id}"]`);theme.utils.refreshElements(this._refresh,t,this),document.dispatchEvent(new CustomEvent("swym:collections-loaded")),e.detail.clearClicked&&(this.sortTriggerLabel.textContent="SORT BY"),this.isFilterChanged=!0,this.connectedCallback()};_triggerDummyClick(e){var t=this.filtersContainer.querySelectorAll(`[name='${e.target.dataset.param}']`),e=this.filtersContainer.querySelector(`[name='${e.target.dataset.param}'][value='${e.target.value}']`),s=this.filtersContainer.querySelector('[name="filter.v.availability"][value="1"]');console.log(e),t.forEach(e=>e.checked=!1),s.click(),e.click()}}class CollectionLeagueHeader extends HTMLElement{constructor(){super(),this._selectors={hiddenLink:"[js-league-hidden-link]",expandBtn:"[js-league-expand]"}}connectedCallback(){this.hiddenLinks=this.querySelectorAll(this._selectors.hiddenLink),this.expandBtn=this.querySelector(this._selectors.expandBtn),this._setListeners()}_setListeners(){this.expandBtn&&this.expandBtn.addEventListener("click",this._expandLinklist)}_expandLinklist=e=>{e.preventDefault(),e.currentTarget.classList.add("hidden"),this.hiddenLinks.forEach(e=>{e.classList.remove("hidden")})}}class Footer extends HTMLElement{constructor(){super(),this._selectors={mobileNav:"[js-mobile-footer-menu]",mobileContent:"[js-mobile-footer-content]"}}connectedCallback(){this.buttons=document.querySelectorAll(this._selectors.mobileNav),this.contents=document.querySelectorAll(this._selectors.mobileContent),this.buttons.forEach(t=>{t.addEventListener("click",e=>{const r=t.getAttribute("data-block-id");this.buttons.forEach(e=>{var t=e.querySelector("[js-plus-svg]"),s=e.querySelector("[js-minus-svg]");r!=e.getAttribute("data-block-id")||t.classList.contains("hidden")?(t.classList.remove("hidden"),s.classList.add("hidden")):(t.classList.add("hidden"),s.classList.remove("hidden"))}),this.contents.forEach(e=>{e.getAttribute("data-block-id")==r&&e.classList.contains("hidden")?e.classList.remove("hidden"):e.classList.add("hidden")})})})}}class ProductMain extends HTMLElement{constructor(){super(),this._selectors={addToCart:"[js-add-to-cart]",price:"[js-price]",form:"[js-product-form]",masterSelect:"[js-master-select]",optionSelector:"[js-product-option-selector]",loader:"loading-spinner",wishlist:"[js-product-wishlist]",sizeGuideModal:"#ProdcutSizeGuideModal",breadcrumbLink:"[js-product-breadcrumb-link]",breadcrumbLinkTitle:"[js-product-breadcrumb-link-title]",teamSelect:"[js-team-select]"}}connectedCallback(){this.addEventListener("variant:change",this._handleVariantChange),this._initProductForm(),this._variantAvailable(),this.wishlist=this.querySelector(this._selectors.wishlist),window.addEventListener("load",this._removeFromWishlist),this._updateBreadcrumb(),this._updateSizeGuideModalIndex(),this._initTeamSelect()}_getRelatedProductsJSON=e=>{return console.log(e),fetch(e).then(e=>e.text()).then(e=>{e=(new DOMParser).parseFromString(e,"text/html").querySelector("[js-collection-json]");return JSON.parse(e.innerHTML)})};_initTeamSelect=()=>{const r=this.querySelector(this._selectors.teamSelect);r&&(async()=>{const s=r.getAttribute("data-product");var e=r.getAttribute("data-tag"),e=await this._getRelatedProductsJSON(`/collections/all/${e}/?view=json`);if(!(e.length<=1)){let t="";e.sort((e,t)=>e.teamName.localeCompare(t.teamName)),e.forEach(e=>{t=`${t}
                        <option value="${e.url}" ${e.handle==s?'selected="selected"':""}>
                          ${e.teamName}
                        </option>`}),r.innerHTML=t,r.addEventListener("change",e=>{e.preventDefault(),window.location.href=e.target.value})}})()};_updateBreadcrumb=()=>{var e,t,s=sessionStorage.getItem("productBreadcrumb");s&&(this.hasAttribute("is-new-pdp")&&(s=JSON.parse(s),e=this.querySelector(this._selectors.breadcrumbLink),t=this.querySelector(this._selectors.breadcrumbLinkTitle),e.href=s.collectionUrl,t.textContent=s.collectionTitle),sessionStorage.removeItem("productBreadcrumb"))};_updateSizeGuideModalIndex=()=>{var e=this.querySelector(this._selectors.sizeGuideModal);if(e){const t=document.querySelector("body");e.addEventListener("open",()=>{t.classList.add("size-guide-open")}),e.addEventListener("close",()=>{t.classList.add("size-guide-close")})}};_removeFromWishlist=()=>{this.wishlist.addEventListener("click",e=>{const s=e.currentTarget;window._swat&&s.classList.contains("swym-added")&&window._swat.fetch(function(e){let t={epi:e.find(({empi:e})=>e==s.dataset.productId).epi,empi:s.dataset.productId,du:s.dataset.productUrl};window._swat.removeFromWishList(t,function(e){s.classList.remove("disabled","swym-added","swym-adding")},function(e){console.log("there was an error while removing the product from wishlist",e,t)})},function(e){console.log("There was an error while fetching the wishlist",e)})})};_initProductForm(){const t=this.querySelector(this._selectors.form),s=this.querySelectorAll(this._selectors.addToCart);t&&t.addEventListener("submit",e=>{e.preventDefault(),s.forEach(e=>{e.setAttribute("disabled","");e=e.querySelector(this._selectors.loader);e&&e.setAttribute("loading","")}),theme.CartAPI.addFromForm(t).then(()=>{s.forEach(e=>{e.removeAttribute("disabled");e=e.querySelector(this._selectors.loader);e&&e.removeAttribute("loading")})}).catch(e=>console.log(e))})}_handleVariantChange=e=>{var{variant:e,priceChange:t}=e.detail;this._updateAddToCartState(e),e&&t&&this._updatePrice(e)};_updateAddToCartState(e){var t=this.querySelectorAll(this._selectors.addToCart);e?e.available?t.forEach(e=>{e.textContent="Add To Cart",e.removeAttribute("disabled")}):t.forEach(e=>{e.textContent="Sold out",e.setAttribute("disabled","")}):t.forEach(e=>{e.textContent="Unavailable",e.setAttribute("disabled","")})}_updatePrice(t){this.querySelectorAll(this._selectors.price).forEach(e=>{e.innerHTML=`${t.compare_at_price?`<span>${theme.utils.formatMoney(t.price,theme.config.money.format)}</span> <s class="product-card__price-sale pl-4">${theme.utils.formatMoney(t.compare_at_price,theme.config.money.format)}</s>`:""} <span>${theme.utils.formatMoney(t.price,theme.config.money.format)}</span>`})}_variantAvailable=()=>{var t=this.querySelector(this._selectors.masterSelect).options,s=this.querySelectorAll(this._selectors.optionSelector);console.log(t),console.log(s);for(let e=0;e<t.length;e++)if(t[e].disabled){var r=t[e].dataset.title;for(let e=0;e<s.length;e++)r==s[e].dataset.title&&s[e].classList.add("disabled")}}}class ProductRecommendations extends HTMLElement{constructor(){super();new IntersectionObserver(((e,t)=>{e[0].isIntersecting&&(t.unobserve(this),fetch(this.dataset.url).then(e=>e.text()).then(e=>{var t=document.createElement("div"),e=(t.innerHTML=e,t.querySelector("product-recommendations"));e&&e.innerHTML.trim().length&&(this.innerHTML=e.innerHTML),document.dispatchEvent(new CustomEvent("swym:collections-loaded"))}).catch(e=>{console.error(e)}))}).bind(this),{rootMargin:"0px 0px 200px 0px"}).observe(this)}}class SearchSpringRecommendations extends HTMLElement{constructor(){super(),this.selectors={grid:"[js-grid]"},this.siteId="cui8ns",this.userId=theme.ssCookies.ssUserId,this.sessionId=theme.ssCookies.ssSessionIdNamespace,this.pageLoadId=theme.ssCookies.ssPageLoadId,this.shopperId=theme.ssCookies.ssShopperId,this.cartProducts=encodeURIComponent(theme.ssCookies.ssCartProducts),this.viewedProducts=encodeURIComponent(theme.ssCookies.ssViewedProducts),this.tag="personal",this.limit=4,this.pdpProductId=this.hasAttribute("data-pdp-product")?this.getAttribute("data-pdp-product"):"",this.apiUrl=`https://${this.siteId}.a.searchspring.io/boost/${this.siteId}/recommend?tags=${this.tag}&limits=`+this.limit+(this.pdpProductId?"&products="+this.pdpProductId:"")+(this.shopperId?"&shopper="+this.shopperId:"")+(this.cartProducts?"&cart="+this.cartProducts:"")+(this.viewedProducts?"&lastViewed="+this.viewedProducts:""),this.data=null}connectedCallback(){this.fetchRecommendations()}fetchRecommendations(){(async()=>{var e=await fetch(this.apiUrl).then(e=>e.json()).then(e=>{if(console.log(e),e?.[0]?.results&&e[0].results.length)return this.data=e[0].results,this.renderProducts(),this.data;this.hideSection()}).catch(e=>{this.hideSection(),console.error(e)});e&&0<e.length&&this._beaconApi(e)})()}_beaconApiRequestData=(e,t)=>{const s=uuidv4(),r=[{category:"searchspring.recommendations.user-interactions",context:{pageLoadId:this.pageLoadId,userId:this.userId,sessionId:this.sessionId,website:{trackingCode:this.siteId}},event:{context:{type:"product-recommendation",tag:this.tag,placement:this.placement},profile:{tag:this.tag,placement:this.placement,seed:this.seed}},id:s,type:"profile."+t}];return e.forEach(e=>{e={category:"searchspring.recommendations.user-interactions",context:{pageLoadId:this.pageLoadId,userId:this.userId,sessionId:this.sessionId,website:{trackingCode:this.siteId}},event:{context:{type:"product-recommendation",tag:this.tag,placement:this.placement},product:{id:e.id,mappings:e.mappings,seed:this.seed}},id:uuidv4(),pid:s,type:"profile.product."+t};r.push(e)}),{method:"POST",headers:{accept:"application/json","content-type":"application/json"},body:JSON.stringify(r)}};_beaconApi=e=>{this.pdpProductId?this.seed=[{sku:this.pdpProductId}]:this.seed=[""],this.placement=this.dataset.placement;var t=this._beaconApiRequestData(e,"render");const s=this._beaconApiRequestData(e,"impression");fetch("https://beacon.searchspring.io/beacon",t).then(e=>e.json()).then(e=>console.log("event render",e)).catch(e=>console.error(e)),this.impressionCalled=!1,document.addEventListener("scroll",()=>{var e;this.impressionCalled||0<=(e=this.getBoundingClientRect()).top&&0<=e.left&&e.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&e.right<=(window.innerWidth||document.documentElement.clientWidth)&&(this.impressionCalled=!0,fetch("https://beacon.searchspring.io/beacon",s).then(e=>e.json()).then(e=>console.log("event impression",e)).catch(e=>console.error(e)))})};renderProducts(){var e=this.querySelector(this.selectors.grid);let t="";e.innerHTML="",this.data.forEach(e=>{t+=this.buildProductCard(e)}),e.innerHTML=t}buildProductCard(e){var t,s,r;return e?.mappings?.core?({name:e,imageUrl:t,price:s,url:r}=e.mappings.core,`
      <a class="product-card group product-card__link p-8 h-full flex flex-col justify-between tabletp:p-16 tabletp:pt-48" href="${r}">
        <div class="product-card__image">
          <img src="${t}" alt="${e}">
        </div>
        <div class="product-card__details flex justify-between group-focus:text-blue desktop:group-hover:text-blue">
          <h3 class="product-card__titlefont-700">${e}</h3>
          <div class="product-card__price-wrapper font-400 tabletp:font-700 tabletp:text-right">
            <span class="product-card__price whitespace-nowrap desktop:pl-4 ">${window.currency.symbol||"$"} ${s}</span>
          </div>
        </div>
      </a>
    `):""}hideSection(){this.classList.add("hidden")}}class Video extends HTMLElement{constructor(){super(),this._selectors={mobileVideo:"[js-video-mobile]",desktopVideo:"[js-video-desktop]",playMobile:"[js-play-mobile]",playDesktop:"[js-play-desktop]",dropContent:"[js-content]"}}connectedCallback(){this.playMobile=this.querySelector(this._selectors.playMobile),this.playDesktop=this.querySelector(this._selectors.playDesktop),this.mobileVideo=this.querySelector(this._selectors.mobileVideo),this.desktopVideo=this.querySelector(this._selectors.desktopVideo),this.playMobile&&this.playMobile.addEventListener("click",this._playMobile),this.playDesktop&&this.playDesktop.addEventListener("click",this._playDesktop),this.dataset.toggleVideo&&(this.mobileVideo&&this.mobileVideo.addEventListener("pause",()=>{this.mobileVideo.controls=!1,this.querySelector(this._selectors.dropContent)&&this.querySelector(this._selectors.dropContent).classList.remove("hidden"),this.playMobile.classList.remove("hidden")}),this.desktopVideo)&&this.desktopVideo.addEventListener("pause",()=>{this.desktopVideo.controls=!1,this.querySelector(this._selectors.dropContent)&&this.querySelector(this._selectors.dropContent).classList.remove("hidden"),this.playDesktop.classList.add("desktop:flex")})}_playMobile=()=>{var e=this.querySelector(this._selectors.mobileVideo);e.controls=!0,e.play(),this.playMobile.classList.add("hidden"),this.querySelector(this._selectors.dropContent)&&this.querySelector(this._selectors.dropContent).classList.add("hidden")};_playDesktop=()=>{var e=this.querySelector(this._selectors.desktopVideo);e.controls=!0,e.play(),this.playDesktop.classList.remove("desktop:flex"),this.querySelector(this._selectors.dropContent)&&this.querySelector(this._selectors.dropContent).classList.add("hidden")}}class searchspringResults extends HTMLElement{constructor(){super(),this._selectors={markup:"[js-searchspring-markup]",resultsCount:"[js-searchspring-results-count]",productsGrid:"[js-searchspring-products-grid]",filters:"[js-searchspring-filters]",sort:"[js-searchspring-sort]",toggleGrid:"[js-searchspring-toggle-grid]",pagination:"[js-searchspring-pagination]",loader:"loading-spinner",collectionTouts:"[js-searchspring-collection-tout]"}}connectedCallback(){document.body.classList.contains("dark")?document.documentElement.style.setProperty("--bg-color","#000000"):document.documentElement.style.setProperty("--bg-color","#ffffff"),this.collectionId=this.dataset.collectionId,this.query=new URLSearchParams(window.location.search).get("query"),this.markup=this.querySelector(this._selectors.markup),this.collectionTouts=this.querySelectorAll(this._selectors.collectionTouts),this.resultsCount=this.querySelector(this._selectors.resultsCount),this.productsGrid=this.querySelector(this._selectors.productsGrid),this.filtersContainer=document.querySelector(this._selectors.filters),this.sortContainer=this.querySelector(this._selectors.sort),this.toggleGrid=this.querySelectorAll(this._selectors.toggleGrid),this.pagination=this.querySelector(this._selectors.pagination),this.loader=this.querySelector(this._selectors.loader),this.filterDrawerLoader=document.querySelector("#FilterDrawer loading-spinner"),this.storeData={filters:"",sort:"",currentPage:1,gridView:""},this.openedFiltersAccordionTabs=[],this.iconPlus=`<svg class="icon icon-plus" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <title>Plus</title>
                      <path d="M7 0V14" stroke="currentColor" stroke-width="1.5"/>
                      <path d="M14 7L-7.15256e-07 7" stroke="currentColor" stroke-width="1.5"/>
                    </svg>`,this.iconMinus=`<svg class="icon icon-minus" viewBox="0 0 13 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <title>Minus</title>
                        <path d="M14 1L-7.15256e-07 0.999999" stroke="currentColor" stroke-width="1.5"/>
                      </svg>`,this.iconHeart=`<svg class="icon icon--full-color icon-heart" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <title>Favorite</title>
                        <path d="M4.45067 13.9082L11.4033 20.4395C11.6428 20.6644 11.7625 20.7769 11.9037 20.8046C11.9673 20.8171 12.0327 20.8171 12.0963 20.8046C12.2375 20.7769 12.3572 20.6644 12.5967 20.4395L19.5493 13.9082C21.5055 12.0706 21.743 9.0466 20.0978 6.92607L19.7885 6.52734C17.8203 3.99058 13.8696 4.41601 12.4867 7.31365C12.2913 7.72296 11.7087 7.72296 11.5133 7.31365C10.1304 4.41601 6.17972 3.99058 4.21154 6.52735L3.90219 6.92607C2.25695 9.0466 2.4945 12.0706 4.45067 13.9082Z" stroke="currentColor" stroke-width="1.5"/>
                      </svg>`,this.iconCarat=`<svg class="icon  icon--full-color icon-carat" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <title>Carat</title>
                        <path d="M1 9.12402L6.85117 4.24805L12.7023 9.12402" stroke="currentColor"/>
                      </svg>`,this._retainHistory(),this._fetchSearchAPI(),this._updateGridView()}_setListeners(){var e=this.filtersContainer.querySelector("[js-close-filter-drawer]"),t=this.filtersContainer.querySelector("[js-searchspring-clear-all]");document.dispatchEvent(new CustomEvent("swym:collections-loaded")),e.addEventListener("click",e=>{e.preventDefault(),document.querySelector("#FilterDrawer").close()}),t.addEventListener("click",e=>{e.preventDefault(),this.filterDrawerLoader.setAttribute("loading",""),this.storeData.filters="",this.storeData.sort="",this.openedFiltersAccordionTabs=[],this._changeHistory(!0,!0),this._fetchSearchAPI()})}_retainHistory(){history.state&&(history.state.gridView&&(this.storeData.gridView=history.state.gridView,this.productsGrid.setAttribute("data-view",history.state.gridView),this.toggleGrid.forEach(e=>{e.removeAttribute("disabled")}),this.querySelector(`[js-searchspring-toggle-grid][data-view=${history.state.gridView}]`).setAttribute("disabled","disabled")),history.state.filters&&(this.storeData.filters=history.state.filters),history.state.sort&&(this.storeData.sort=history.state.sort),history.state.currentPage)&&(this.storeData.currentPage=history.state.currentPage)}_changeHistory(t=!1,s=!1){let r={};if((r=history.state?history.state:r).filters=this.storeData.filters,r.sort=this.storeData.sort,r.currentPage=this.storeData.currentPage,r.gridView=this.storeData.gridView,t){let e=(this.query?"":"?")+this.storeData.filters+this.storeData.sort+"&page="+this.storeData.currentPage;s&&(e=1!=this.storeData.currentPage?`${this.query?"":"?"}&page=`+this.storeData.currentPage:"");t=""+window.location.pathname+(this.query?"?query="+this.query:"")+e;history.pushState(r,"",t)}else history.pushState(r,"")}_updateGridView(){this.toggleGrid.forEach(e=>{e.addEventListener("click",e=>{e.preventDefault();var e=e.currentTarget,t=e.dataset.view;this.toggleGrid.forEach(e=>{e.removeAttribute("disabled")}),e.setAttribute("disabled","disabled"),this.productsGrid.setAttribute("data-view",t),this.storeData.gridView=t,this._changeHistory(!1,!1)})})}_loadNextPage(){var e=this.pagination.querySelector("[js-searchspring-next-page]");e&&e.addEventListener("click",e=>{e.preventDefault(),this.loader.setAttribute("loading",""),this.storeData.currentPage++,this._changeHistory(!0,!1),this._fetchSearchAPI(!0)})}_updateFiltersAccordion(){this.openedFiltersAccordionTabs.forEach(e=>{e=this.filtersContainer.querySelector(`[js-accordion-header][aria-controls=${e.getAttribute("aria-controls")}]`);e&&(e.setAttribute("aria-expanded",!0),e.nextElementSibling.setAttribute("aria-hidden",!1))})}_handleSortChange(){this.sortContainer.querySelector("select").addEventListener("change",e=>{e.preventDefault(),this.storeData.sort=e.currentTarget.value,this._changeHistory(!0,!1),this._fetchSearchAPI()})}_handleFiltersChange(){const s=this.filtersContainer.querySelector("form");s.addEventListener("input",e=>{e.preventDefault(),this.filterDrawerLoader.setAttribute("loading",""),this.openedFiltersAccordionTabs=s.querySelectorAll('[js-accordion-header][aria-expanded="true"]');e=s.querySelectorAll("[js-searchspring-filter-input]:checked");let t="";e.forEach(e=>{t=""+t+e.value}),this.storeData.filters=t,this._changeHistory(!0,!1),this._fetchSearchAPI()})}_sortComponent(e){let t=this.query?"":'<option value="" disabled selected="selected">SORT BY</option>',s="";return e.options.forEach(e=>{1==e.active&&(s=e.label),t=`${t}<option value="&sort.${e.field}=${e.direction}" ${1==e.active?'selected="selected"':""}>${e.label}</option>`}),`<select name="sort_by" class="sort-trigger__select w-full h-full cursor-pointer opacity-0" id="SearchspringSort" aria-describedby="a11y-refresh-page-message">${t}</select>
            <label for="SearchspringSort" class="sort-trigger__label h2 absolute top-0 left-0 w-full h-full z-[-1] flex justify-center items-center dark:text-white">
              <span>${s?""+s:"SORT BY"}</span>
              <span class="ml-8 w-[10px] rotate-180 leading-[0] hidden desktop:block">${this.iconCarat}</span>
            </label>`}_filtersComponent(e){var t=e.facets;let a="";return t.forEach((s,e)=>{var t=s.values.filter(e=>e.active),r=Math.ceil(s.values.length/2);let i="";s.values.forEach((e,t)=>{t=`FilterSort-${s.field}-`+t;i=`${i}
                        <li class="filter-sort__value">
                          <div class="filter-value">
                            <input type="checkbox"
                              name="${e.label}"
                              value="${"range"==e.type?`&filter.${s.field}.low=${e.low}&filter.${s.field}.high=`+e.high:`&filter.${s.field}=`+e.value}"
                              id="${t}"
                              class="filter-value__input visually-hidden"
                              ${e.active?"checked":""}
                              ${0==e.count&&0==e.active?"disabled":""}
                              js-searchspring-filter-input
                            >
                            <label for="${t}" class="filter-value__label ${0==e.count&&0==e.active?"disabled opacity-30":""}">
                              <span class="h2 break-words">${"single"==s.multiple?"Yes"==e.label?"YES":"NO":""+e.label}</span> 
                              <span class="filter-value__label-count h2 font-coolvetica font-400 hidden"> (${e.count})</span>
                            </label>
                          </div>
                        </li>`}),a=`${a}
                        <div class="filter-sort accordion-item border-b border-black" data-index="${e}" js-accordion-item>
                          <button type="button" class="filter-sort__label accordion-header h2 py-16 w-full flex justify-between items-center" aria-expanded="false" aria-controls="${s.field}-master-filter" js-accordion-header>
                            <div class="text-16 flex justify-start items-center">
                              <span class="filter-sort__label-count w-40 font-coolvetica font-500 text-left -mb-4">${t.length}</span>
                              <span class="filter-sort__label-text flex-1">${s.label}</span>
                            </div>
                            <span class="filter-sort__label-icon w-[14px]">${this.iconPlus}${this.iconMinus}</span>
                          </button>
                          <div id="${s.field}-master-filter" class="filter-sort__values-container accordion-content" aria-hidden="true" js-accordion-content>
                            <ul class="filter-sort__values pb-16 pl-40 grid grid-cols-2 gap-4" role="list" style="--num-rows: ${r};">${i}</ul>   
                          </div>
                        </div>`}),`<form class="searchspring-filters__form h-full flex flex-col">
              <div class="filter-sort__active-filter-count border border-black dark:border-white mx-16 h-56 flex justify-center items-center dark:text-white">
                <span class="h2 text-16">FILTERS</span><span class="ml-4 mr-8 h2 font-coolvetica font-400 mb-[-3px]">(${e.filterSummary.length})</span>
              </div>          
              <div class="filter-sort__filters-container flex-1 max-h-full overflow-y-auto mt-32 px-16">
                <s-accordion class="block border-t border-black dark:border-white" data-manual-collapse="false" js-accordion>${a}</s-accordion>
              </div>
              <div class="filter-sort__footer absolute left-0 bottom-0 w-full px-32 pt-16 pb-24 flex flex-col items-center">
                <button type="button" class="no-js-hidden btn btn--black w-full" js-close-filter-drawer>
                  VIEW ${e.pagination.totalResults} RESULTS
                </button>
                <button type="button" class="active-filters__remove link h2 mt-16 border-b border-black dark:border-white pb-[2px] dark:text-white" js-searchspring-clear-all>
                  CLEAR ALL FILTERS
                </button>
              </div>
            </form>`}_quickAddComponent(e){let a=e.name,t="";e.ss_tags.forEach(e=>{e.includes("upsell_")&&(t=e.replace("upsell_","").trim())});var s=JSON.parse(e.options.replaceAll("&quot;",'"'));let o="";s.forEach(e=>{o="option"+e.position});s=JSON.parse(e.variants.replaceAll("&quot;",'"'));const n=s.filter(e=>0!=e.inventory_quantity);let l="";return s.forEach(t=>{var e=`quick-add-swatch-${t.product_id}-`+t.id,s="quick-add-swatch-"+t.product_id,r=t[o];let i=r.toUpperCase();"SMALL"==i?i="S":"MEDIUM"==i?i="M":"LARGE"==i?i="L":"ONE SIZE"==i?i="OS":"ONE SIZE FITS ALL"==i?i="OSFA":"SMALL/MEDIUM"==i?i="S/M":"LARGE/XLARGE"==i&&(i="L/XL"),l=`${l}
                          <div class="product-card-quick-add__variant p-8 flex">
                            <input 
                            aria-label="${a}, size ${r}"
                            id="${e}"
                            class="product-card-quick-add__variant-input"
                            type="radio" 
                            name="${s}"
                            value="${r}" 
                            data-variant-id="${t.id}"
                            ${n.find(e=>e.id==t.id)?"":"disabled"}
                            js-quick-add-variant>
                            <label for="${e}" class="product-card-quick-add__variant-label text-white h2 leading-[18px] flex justify-center items-center w-48 h-48 border border-white rounded-[50%] relative">${i}</label>
                          </div>
                        `}),`<quick-add class="product-card__quick-add" js-quick-add-copy ${t?`data-upsell="${t}"`:""}>
              ${"1"==e.ss_available?`${1<s.length?`<div class="product-card-quick-add__variants-container bg-black bg-opacity-90 py-16 px-40 desktop:px-16 extrawide:px-40">
                    <div class="product-card-quick-add__variants-header h2 font-coolvetica font-400 text-white mb-16">SELECT SIZE:</div>
                    <fieldset class="product-card-quick-add__variants flex flex-wrap justify-center items-start -m-8">${l}</fieldset>
                  </div>`:""}
                  <button type="button" class="product-card-quick-add__atc btn btn--black w-full rounded-none" data-id="${n[0].id}" ${1<s.length?"disabled":""} js-quick-add-atc>
                    ${1<s.length?"SELECT A SIZE":"ADD TO CART"}  
                  </button>`:'<div class="product-card-quick-add__sold-out h2 text-16 bg-black text-white py-16 text-center">SOLD OUT</div>'}
            </quick-add>`}_productCardComponent(e,t){var s;let r="",i=e.name,a=(e.mfield_data_product_prefix&&(r=`<div class="font-400">${e.mfield_data_product_prefix}</div>`),i.includes(" - ")&&(i=i.split(" - ")[0]),s=`${r}<div class="product-card__title font-700">${i}</div>`,""),o="bg-blue";new Date(e.published_at),new Date(Date.now());"1"!=e.ss_available?(a="SOLD OUT",o="bg-black"):e.mfield_data_product_badge&&(a=e.mfield_data_product_badge);let n="lazy";t<4&&(n="eager");var t=this._quickAddComponent(e),l=e.ss_image_alt&&""!==e.ss_image_alt.trim(),c=1==e.mfield_custom_app_download||"true"==e.mfield_custom_app_download||"1"==e.mfield_custom_app_download||1==e.mfield_custom_app_download;return`<product-card class="product-card block h-full relative bg-white overflow-hidden group" data-quick-add-open="false">
              <a href="${e.url}" class="product-card__link p-8 h-full hidden desktop:flex flex-col justify-between tabletp:p-16 tabletp:pt-48" title="${i}" js-product-link>
                <div class="product-card__image product-card__image--featured ${l?"transition-opacity group-focus:opacity-0 desktop:group-hover:opacity-0":""}" style="aspect-ratio: 1/1">
                  <img src="${e.imageUrl}" class="block w-full h-full object-cover" loading="${n}" alt="${e.name}" />
                </div>
                ${l?`<div class="product-card__image product-card__image--hover absolute top-0 left-0 w-full opacity-0 transition-opacity group-focus:opacity-100 desktop:group-hover:opacity-100" style="aspect-ratio: 1/1">
                  <img src="${e.ss_image_alt}" class="block w-full h-full object-cover" loading="eager" alt="${e.name}" />
                </div>`:""}
                <div class="product-card__info text-small uppercase w-full pt-4 relative tabletp:pt-[10px] tabletp:flex tabletp:justify-between tabletp:items-end tabletp:text-14 tabletp:leading-[21px]">
                  <div class="product-card__title-wrapper desktop:w-[75%]">${s}</div>
                  <div class="product-card__price-wrapper font-400 tabletp:font-700 tabletp:text-right">
                    ${"1"==e.ss_on_sale?`<s class="product-card__price-compare pr-4 whitespace-nowrap desktop:pr-0">$${e.msrp}</s>`:""}
                    <span class="product-card__price whitespace-nowrap desktop:pl-4 ${"1"==e.ss_on_sale?"text-red":""}">$${e.price}</span>
                  </div>
                  ${a?`<div class="product-card__badge absolute top-0 left-0 -translate-y-full text-10 font-700 leading-[10px] ${o} p-4 px-[6px] text-white uppercase rounded-[4px] tracking-[0.06em] tabletp:py-8 tabletp:px-12">${a}</div>`:""}
                </div>
              </a>

              <div class="product-card__mobile-link p-8 h-full flex desktop:hidden flex-col justify-between">
                <div class="product-card__image-carousel">
                  <s-carousel class="block relative" data-options='{"cssMode": false, "slidesPerView": "1", "loop": true, "pagination": {"el": ".product-card-pagination-${e.id}", "clickable": false}, "touchEventsTarget": "container", "simulateTouch": true, "touchRatio": 1, "touchAngle": 45, "threshold": 5}' data-init="belowDesktop">
                    <div id="productCardCarousel-${e.id}" class="swiper" js-carousel>
                      <div class="swiper-wrapper">
                        <div class="swiper-slide" js-carousel-slide>
                          <a href="${e.url}" class="block w-full">
                            <img src="${e.imageUrl}" loading="${n}" alt="${e.name}" class="block w-full" />
                          </a>
                        </div>
                        ${l?`<div class="swiper-slide" js-carousel-slide>
                          <a href="${e.url}" class="block w-full">
                            <img src="${e.ss_image_alt}" loading="eager" alt="${e.name}" class="block w-full" />
                          </a>
                        </div>`:""}
                      </div>
                    </div>
                    <div class="swiper-pagination z-[1] product-card-pagination-${e.id}"></div>
                  </s-carousel>
                </div>
                <a href="${e.url}" class="product-card__info-link text-small uppercase w-full pt-4 relative" js-product-link>
                  <div class="product-card__title-wrapper desktop:w-[75%]">${s}</div>
                  <div class="product-card__price-wrapper font-400 tabletp:font-700 tabletp:text-right">
                    ${"1"==e.ss_on_sale?`<s class="product-card__price-compare pr-4 whitespace-nowrap desktop:pr-0">$${e.msrp}</s>`:""}
                    <span class="product-card__price whitespace-nowrap desktop:pl-4 ${"1"==e.ss_on_sale?"text-red":""}">$${e.price}</span>
                  </div>
                  ${a?`<div class="product-card__badge absolute top-0 left-0 -translate-y-full text-10 font-700 leading-[10px] ${o} p-4 px-[6px] text-white uppercase rounded-[4px] tracking-[0.06em] tabletp:py-8 tabletp:px-12">${a}</div>`:""}
                </a>
              </div>

              <button type="button" aria-label="Add to wishlist" data-with-epi="true" class="product-card__wishlist link p-4 absolute top-[3px] left-4 z-[1] leading-[0] tabletp:top-8 tabletp:left-8 tabletp:w-44 tabletp:p-[10px] w-24" data-swaction="addToWishlist" data-product-id="${JSON.parse(e.uid)}" data-variant-id="${e.variant_id[0]}" data-product-url="${e.url}" js-product-card-wishlist>${this.iconHeart}</button>

              ${"Virtual Gift Card"==i||c?"":`
              <button type="button" aria-label="Open quick add tab" class="product-card__quick-add-trigger-mobile desktop:hidden link p-[5px] absolute top-8 right-4 z-[1] leading-[0] tabletp:top-8 tabletp:right-8 tabletp:w-44 tabletp:p-[13px]" js-quick-add-trigger>ADD</button>
              <button type="button" aria-label="Open quick add tab" class="product-card__quick-add-trigger-desktop hidden desktop:inline-block border-[3px] border-transparent link p-4 absolute top-[3px] right-4 z-[1] tabletp:top-8 tabletp:right-8 tabletp:p-[10px]" js-quick-add-trigger>
                <div class="quick-add__add">ADD</div>
                <div class="quick-add__close rotate-45 hidden w-20">${this.iconPlus}</div>
              </button>
              <div class="product-card__quick-add-wrapper block w-full absolute left-0 bottom-0 z-[1] translate-y-full">${t}</div>
              `}
              
            </product-card>
            <a href="${e.url}" class="product-card-alt relative flex justify-center" js-product-link>
              <div class="product-card-alt__image w-full p-8 pb-24 ${"SOLD OUT"==a?"opacity-50":""}">
                <img src="${e.imageUrl}" loading="${n}" alt="${e.name}" class="block w-full" />
              </div> 
              <div class="product-card-alt__info-wrapper absolute top-0 left-0 w-full h-full bg-white dark:bg-black z-[1] flex justify-center items-center opacity-0 transition-opacity">
                <div class="product-card-alt__info text-small leading-none uppercase w-full text-left p-16">
                  <div class="product-card-alt__title-wrapper">${s}</div>
                  <div class="product-card-alt__price-wrapper font-400">
                    ${"1"==e.ss_on_sale?`<s class="product-card-alt__price-compare pr-4">$${e.msrp}</s>`:""}
                    <span class="product-card-alt__price">$${e.price}</span>
                  </div>
                </div>
              </div> 
              ${"SOLD OUT"==a?`<div class="product-card-alt__badge absolute h2 bottom-12 bg-blue py-[5px] px-12 text-white border border-black tracking-[0.06em]">${a}</div>`:""}
            </a>`}_paginationComponent(e){return 0!=e.nextPage?'<button type="button" class="searchsrping-results__next-page btn px-48 block mx-auto" js-searchspring-next-page>LOAD MORE</button>':""}_renderMarkup(e,t){if(""!==e.merchandising.redirect)return window.location.href=e.merchandising.redirect,!1;this.resultsCount.innerHTML=`${0==e.pagination.totalResults?"No":""+e.pagination.totalResults} Results Found For "${this.query}"`;var r=e.results;if(r.length){let s="";r.forEach((e,t)=>{e=this._productCardComponent(e,t);s+=`<li class="searchsrping-results__grid-item border border-black dark:border-white ml-[-1px] mt-[-1px] relative column-${t%4+1}">${e}</li>`}),console.log("this.collectionTouts",this.collectionTouts),t?this.productsGrid.insertAdjacentHTML("beforeend",s):this.productsGrid.innerHTML=s,this.collectionTouts.forEach(e=>{this.productsGrid.appendChild(e)}),console.log("this.productsGrid",this.productsGrid);r=this._filtersComponent(e),t=(this.filtersContainer.innerHTML=r,this._updateFiltersAccordion(),this._handleFiltersChange(),this._sortComponent(e.sorting)),r=(this.sortContainer.innerHTML=t,this._handleSortChange(),this._paginationComponent(e.pagination));this.pagination.innerHTML=r,this._loadNextPage(),this.markup.classList.remove("hidden"),this.collectionId&&this.resultsCount.classList.add("hidden"),this._setListeners()}else this.markup.classList.add("hidden"),this.collectionId&&(this.resultsCount.innerHTML="No Products Found",this.resultsCount.classList.remove("hidden"))}_fetchSearchAPI(t=!1){var e=48*parseInt(this.storeData.currentPage),e=`https://cui8ns.a.searchspring.io/api/search/search.json?siteId=cui8ns&resultsFormat=json${this.query?"&q="+this.query:""}&redirectResponse=minimal&page=${t?this.storeData.currentPage:1}&resultsPerPage=${t?48:e}${this.storeData.filters}${this.collectionId?"&bgfilter.collection_id="+this.collectionId:""}&bgfilter.is_published=yes`+this.storeData.sort;fetch(e,{method:"GET",headers:{accept:"application/json"}}).then(e=>e.json()).then(e=>{this._renderMarkup(e,t),this.loader.removeAttribute("loading"),this.filterDrawerLoader.removeAttribute("loading")}).catch(e=>console.error(e))}}class Blog extends HTMLElement{constructor(){super(),this._selectors={articlesGrid:"[js-articles-grid]",nextPageBtn:"[js-blog-next-page]",loader:"loading-spinner"}}connectedCallback(){this.articlesGrid=this.querySelector(this._selectors.articlesGrid),this.nextPageBtn=this.querySelector(this._selectors.nextPageBtn),this.loader=this.querySelector(this._selectors.loader),this.nextPageBtn&&this.nextPageBtn.addEventListener("click",this._loadNextPage)}_updateHistory(e,t,s){let r={};(r=history.state?history.state:r)[e]=t,s?history.pushState(r,"",s):history.pushState(r,"")}_getArticles(e){return fetch(e).then(e=>e.text()).then(e=>{return(new DOMParser).parseFromString(e,"text/html")})}_loadNextPage=async()=>{this.loader.setAttribute("loading","");var e=this.querySelector(this._selectors.nextPageBtn),t=e.dataset.url,s=await this._getArticles(t),r=s.querySelector(this._selectors.articlesGrid).innerHTML,s=s.querySelector(this._selectors.nextPageBtn);this.articlesGrid.insertAdjacentHTML("beforeend",r),this._updateHistory("blogs",this.articlesGrid.innerHTML,t),s?e.setAttribute("data-url",s.dataset.url):e.remove(),this.loader.removeAttribute("loading")}}class AuRedirect extends HTMLElement{constructor(){super(),this._selectors={modal:"#AuRedirect",close:"[js-au-redirect-close]"}}connectedCallback(){this._getCookie("au_redirect")||this._isAustralia().then(e=>{e?this._initAuRedirect():this._setCookie("au_redirect","true",30)})}_setCookie(e,t,s){var r=new Date,s=(r.setTime(r.getTime()+24*s*60*60*1e3),"expires="+r.toUTCString());document.cookie=e+"="+t+";"+s+";path=/"}_getCookie(e){var s=e+"=",r=decodeURIComponent(document.cookie).split(";");for(let t=0;t<r.length;t++){let e=r[t];for(;" "==e.charAt(0);)e=e.substring(1);if(0==e.indexOf(s))return e.substring(s.length,e.length)}return""}_initAuRedirect(){var e=this.querySelector(this._selectors.modal);if(null!==sessionStorage.getItem("auPopup"))return!1;e.open();var t=e.querySelector(this._selectors.close);e.addEventListener("close",()=>{this._preventPopup()}),t.addEventListener("click",()=>{this._preventPopup()})}_preventPopup(){null==sessionStorage.getItem("auPopup")&&sessionStorage.setItem("auPopup",!0)}async _isAustralia(){let e=!1;if(this._getCookie("country_code")){var t=this._getCookie("country_code");e="AU"==t||"NZ"==t}else try{var s=await this._ipCheck();this._setCookie("country_code",s.country_code,120),e="AU"==s.country_code||"NZ"==s.country_code}catch(e){console.error("An error occurred:",e)}return e}async _ipCheck(){return(await fetch("https://api.ipstack.com/check?access_key=a620efff631ada82fa0367966e34a8dc",{headers:{"Content-Type":"application/json"}})).json()}}class HatRandomizer extends HTMLElement{constructor(){super(),this._selectors={heading:"[js-randomizer-heading]",sizeBtn:"[js-size-btn]",atc:"[js-randomizer-atc]",shuffleBtn:"[js-shuffle-btn]"},this.sizeWrapper=this.querySelector(".page-randomizer__sizes"),this.shuffleWrapper=this.querySelector(".page-randomizer__shuffle"),this.products=this.querySelector(".page-randomizer__products"),this.heading=this.querySelector(this._selectors.heading),this.sizes=this.querySelectorAll(this._selectors.sizeBtn),this.atc=this.querySelector(this._selectors.atc),this.selectedSize=null}connectedCallback(){this.querySelectorAll(this._selectors.sizeBtn).forEach(e=>{e?.addEventListener("click",this._handleSizeBtn)}),this.querySelector(this._selectors.atc)?.addEventListener("click",this._handleAtc),this.querySelector(this._selectors.shuffleBtn)?.addEventListener("click",this._handleShuffle)}_handleSizeBtn=e=>{e.preventDefault(),this.selectedSize=e.target,"SPAN"==e.target.tagName&&(this.selectedSize=e.target?.parentElement,e.target?.dataset?.size||(this.selectedSize=e.target?.parentElement));e=document.querySelector(`[value="${this.selectedSize.dataset.sizeValue}"]`);e&&e?.click(),this.sizes.forEach(e=>{e?.classList?.remove("active")}),this.selectedSize.classList.add("active"),this.products?.classList?.add("active"),this.querySelector(this._selectors.shuffleBtn)?.click(),this.heading.innerHTML=this.heading.dataset.afterText,this.sizeWrapper?.classList?.add("hidden"),this._selectVariant(),this.shuffleWrapper?.classList?.remove("hidden")};_selectVariant(){var e=document.querySelector("#randomCarousel .swiper-slide-active")?.dataset?.variants?.split("|");const t=document.querySelector("[js-size-btn].active")?.dataset?.size?.replace(","," "),s=e.filter(e=>e.split(",")[1]==t)[0]?.split(",")[0];e=e.filter(e=>e.split(",")[0]==s)[0]?.split(",")[2];this.atc.parentElement?.classList?.remove("hidden"),this.atc.dataset.variantId=s,"true"==e?(this.atc.innerHTML=this.selectedSize.dataset.size?.replace(","," ")+" - Add to cart",this.atc.classList.remove("disabled")):(this.atc.innerHTML="Sold out",this.atc.classList.add("disabled"))}_handleAtc=e=>{e.preventDefault();e=e.currentTarget.dataset.variantId;e&&"undefined"!=e&&theme.CartAPI.add({items:[{id:e,quantity:1,properties:{_almost_gone:"randomizer"}}]}).then(e=>{console.log("ATC Response",e)}).catch(e=>{console.log(e)})};_handleShuffle=e=>{e.preventDefault();const t=document.querySelector("[js-size-btn].active")?.dataset?.size?.replace(","," "),s=[...document.querySelectorAll("#randomCarousel .swiper-slide")].filter(e=>-1<e.dataset.variants.indexOf(t+",true")).map(e=>e.dataset.swiperSlideIndex),r=Math.floor(Math.random()*s.length);e=[...document.querySelectorAll("#randomCarousel .swiper-slide")].filter(e=>e.dataset.swiperSlideIndex==s[r])[0];(this.products?.querySelector("s-carousel"))?.carousel?.slideTo(document.querySelector("#randomCarousel").swiper.getSlideIndex(e)),this._selectVariant()}}class VirtualLocker extends HTMLElement{constructor(){super(),this._selectors={loadMoreButton:"[js-load-more-vl]",lockerItems:"[js-locker-item]",modal:"#VirtualLockerItem",modalTitle:".modal-product-title",modalImage:".modal-product-image",modalSubtitle:".modal-product-subtitle",shareButton:"#shareButton"},this.itemsPerPage=24,this.currentPage=1}connectedCallback(){this.loadMoreButton=document.querySelector(this._selectors.loadMoreButton),this.lockerItems=document.querySelectorAll(this._selectors.lockerItems),this.modal=document.querySelector(this._selectors.modal),this.totalItems=this.lockerItems.length,this.totalPages=Math.ceil(this.totalItems/this.itemsPerPage),this._showItems(this.currentPage),this.loadMoreButton&&this.loadMoreButton.addEventListener("click",this._loadMoreItems),this.lockerItems.forEach(t=>{t.addEventListener("click",e=>this._handleItemClick(e,t))});var e=document.querySelector(this._selectors.shareButton);e&&e.addEventListener("click",this._shareProduct),this.modal.addEventListener("close",this._resetModalContent)}_showItems=e=>{const s=(e-1)*this.itemsPerPage,r=s+this.itemsPerPage;this.lockerItems.forEach((e,t)=>{t>=s&&t<r&&(e.style.display="block")}),this.currentPage>=this.totalPages&&(this.loadMoreButton.style.display="none")};_loadMoreItems=()=>{this.currentPage++,this._showItems(this.currentPage)};_handleItemClick=(e,t)=>{t={title:t.getAttribute("data-title")||"Untitled Product",subtitle:t.getAttribute("data-subtitle")||"",image:t.getAttribute("data-image")||"",handle:t.getAttribute("data-product-handle")};this._updateModalContent(t),this.modal.open()};_updateModalContent=e=>{var t=this.modal.querySelector(this._selectors.modalTitle),s=this.modal.querySelector(this._selectors.modalImage),r=this.modal.querySelector(this._selectors.modalSubtitle);t.innerText=e.title,s.src=e.image,r.innerText=e.subtitle,this.modal.setAttribute("data-product-handle",e.handle)};_resetModalContent=()=>{var e=this.modal.querySelector(this._selectors.modalTitle),t=this.modal.querySelector(this._selectors.modalImage),s=this.modal.querySelector(this._selectors.modalSubtitle);e.innerText="",s.innerText="",t.src="",t.alt=""};_shareProduct=()=>{var e=encodeURIComponent(this.modal.querySelector(this._selectors.modalTitle).innerText),t=encodeURIComponent(this.modal.querySelector(this._selectors.modalImage).src),s=encodeURIComponent(this.modal.querySelector(".modal-product-subtitle").innerText),e=window.location.origin+`/pages/locker-item?title=${e}&image=${t}&subtitle=`+s;navigator.share?navigator.share({title:"Check out this product I have in my locker!",url:e}).then(()=>console.log("Thanks for sharing!")).catch(console.error):navigator.clipboard.writeText(e).then(()=>{alert("Link copied to clipboard!")})}}class LockerItem extends HTMLElement{constructor(){super(),this._selectors={productTitle:"#product-title",productImage:"#product-image",productSubtitle:"#product-subtitle"}}connectedCallback(){var e=this._getQueryParam("title"),t=this._getQueryParam("image"),s=this._getQueryParam("subtitle");e&&t?this._updateModalContent(decodeURIComponent(e),decodeURIComponent(t),decodeURIComponent(s)):console.error("Missing product data in the URL.")}_getQueryParam(e){return new URLSearchParams(window.location.search).get(e)}_updateModalContent(e,t,s){var r=document.querySelector(this._selectors.productTitle),i=document.querySelector(this._selectors.productImage),a=document.querySelector(this._selectors.productSubtitle);r&&(r.innerText=e),i&&(i.src=t),a&&(a.innerText=s)}}class DropsCollections extends HTMLElement{constructor(){super(),this._selectors={loadMoreButton:"[js-load-more]",productGrid:"[js-products-grid]"},this.currentLimit=parseInt(this.dataset.currentLimit)||12,this.loadMoreAmount=8}connectedCallback(){this.loadMoreButton=this.querySelector(this._selectors.loadMoreButton),this.loadMoreButton&&this.loadMoreButton.addEventListener("click",this._loadMore),this.productGrid=this.querySelector(this._selectors.productGrid),this.productItems=this.productGrid.querySelectorAll(".product-item"),this._checkLoadMoreButton()}_loadMore=()=>{this.currentLimit+=this.loadMoreAmount,this._showProducts(),this._checkLoadMoreButton()};_showProducts(){this.productItems.forEach((e,t)=>{t<this.currentLimit?e.classList.remove("hidden"):e.classList.add("hidden")})}_checkLoadMoreButton(){this.productItems.length<=this.currentLimit&&this.loadMoreButton.remove()}}customElements.define("s-collection-grid",CollectionGrid),customElements.define("collection-league-header",CollectionLeagueHeader),customElements.define("s-footer",Footer),customElements.define("article-video",Video),customElements.define("s-product",ProductMain),customElements.define("product-recommendations",ProductRecommendations),customElements.define("searchspring-recommendations",SearchSpringRecommendations),customElements.define("searchspring-results",searchspringResults),customElements.define("s-blog",Blog),customElements.define("au-redirect",AuRedirect),customElements.define("hat-randomizer",HatRandomizer),customElements.define("virtual-locker",VirtualLocker),customElements.define("locker-item",LockerItem),customElements.define("drops-collections",DropsCollections);class Account extends HTMLElement{constructor(){super(),this._selectors={addressCountrySelect:"[js-country-select]",editAddressModal:"[js-edit-address-modal]",editAddressOpen:"[js-edit-address]",editAddressForm:"[js-edit-address-form]",deleteAddressButton:"[js-delete-address]",ordersContainer:"[js-orders]",ordersPagination:"[js-next-page]",order:"[js-order]",orderHistory:"[js-order-history]",accountInfo:"[js-account-info]",editAddressContainer:"[js-edit-address-container]",addAddressContainer:"[js-add-address-container]",closeContainers:"[js-close-containers]",viewOrders:"[js-view-orders]",addNewAddress:"[js-add-new-address]"}}connectedCallback(){this.countrySelects=this.querySelectorAll(this._selectors.addressCountrySelect),this.editAddressModal=this.querySelector(this._selectors.editAddressModal),this.openEditAddress=this.querySelectorAll(this._selectors.editAddressOpen),this.editAddressForms=this.querySelectorAll(this._selectors.editAddressForm),this.deleteAddressButtons=this.querySelectorAll(this._selectors.deleteAddressButton),this.ordersContainer=this.querySelector(this._selectors.ordersContainer),this.ordersPagination=this.querySelector(this._selectors.ordersPagination),this.orderHistory=this.querySelector(this._selectors.orderHistory),this.accountInfo=this.querySelector(this._selectors.accountInfo),this.editAddressContainer=this.querySelector(this._selectors.editAddressContainer),this.addAddressContainer=this.querySelector(this._selectors.addAddressContainer),this.closeContainers=this.querySelectorAll(this._selectors.closeContainers),this.viewOrders=this.querySelector(this._selectors.viewOrders),this.addNewAddress=this.querySelector(this._selectors.addNewAddress),this._setupEventListeners(),this._setupCountries()}_setupCountries(){Shopify&&Shopify.CountryProvinceSelector&&(new Shopify.CountryProvinceSelector("AddressCountryNew","AddressProvinceNew",{hideElement:"AddressProvinceContainerNew"}),this.countrySelects.forEach(e=>{e=e.dataset.formId;new Shopify.CountryProvinceSelector("AddressCountry_"+e,"AddressProvince_"+e,{hideElement:"AddressProvinceContainer_"+e})}))}_setupEventListeners(){this.ordersPagination&&this.ordersPagination.addEventListener("click",this._addOrders),this.openEditAddress.forEach(e=>{e.addEventListener("click",this._handleOpenEditAddress)}),this.deleteAddressButtons.forEach(e=>{e.addEventListener("click",this._handleDeleteAddress)}),this.viewOrders.addEventListener("click",this._viewOrders),this.addNewAddress.addEventListener("click",this._addNewAddress),this.closeContainers.forEach(e=>{e.addEventListener("click",this._closeContainers)})}_addOrders=async()=>{var e=this.ordersPagination.dataset.url,e=await this._getOrders(e),t=e.querySelector(this._selectors.ordersContainer).innerHTML,e=e.querySelector(this._selectors.ordersPagination);this.ordersContainer.insertAdjacentHTML("beforeend",t),e?this.ordersPagination.dataset.url=e.dataset.url:this.ordersPagination.remove(),this.ordersContainer.connectedCallback()};_getOrders(e){return fetch(e).then(e=>e.text()).then(e=>{return(new DOMParser).parseFromString(e,"text/html")})}_handleOpenEditAddress=e=>{e.stopPropagation();var e=e.currentTarget.dataset.form,e=document.querySelector("#address_form_"+e),t=document.querySelector("[js-account-info]"),s=document.querySelector("[js-edit-address-container]");e.classList.remove("hidden"),e.querySelector('[name="address[first_name]"]').focus(),t.classList.add("hidden"),s.classList.remove("hidden")};_handleDeleteAddress=e=>{e=e.currentTarget.dataset.target;confirm("Are you sure you want to delete this address?")&&Shopify.postLink(e,{parameters:{_method:"delete"}})};_handleCloseEditAddress=e=>{this.editAddressForms.forEach(e=>{e.classList.add("hidden")})};_viewOrders=e=>{e.preventDefault();var e=document.querySelector("[js-account-info]"),t=document.querySelector("[js-order-history]");e.classList.add("hidden"),t.classList.remove("hidden")};_addNewAddress=e=>{e.preventDefault();var e=document.querySelector("[js-account-info]"),t=document.querySelector("[js-add-address-container]");e.classList.add("hidden"),t.classList.remove("hidden")};_closeContainers=e=>{e.preventDefault();var e=document.querySelector("[js-account-info]"),t=document.querySelector("[js-add-address-container]"),s=document.querySelector("[js-edit-address-container]"),r=document.querySelector("[js-order-history]");e.classList.remove("hidden"),r.classList.add("hidden"),t.classList.add("hidden"),s.classList.add("hidden")}}customElements.define("s-account",Account);

(function () {
  const W = window;

  // ==================================================
  // GLOBAL CLEANUP FROM PREVIOUS INSTANCE
  // ==================================================

  if (W.__hcnCleanup) {
    W.__hcnCleanup();
  }

  // --------------------------------------------------
  // Helpers
  // --------------------------------------------------

  const $ = (s, r = document) => r.querySelector(s);

  const $$ = (s, r = document) =>
    [...r.querySelectorAll(s)];

  const esc = s =>
    String(s).replace(
      /[&<>"']/g,
      c =>
        ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        }[c])
    );

  const clean = t =>
    t.textContent.trim().replace(/\s+/g, ' ');

  const title = s => s.toUpperCase();

  const fixHref = h => {
    if (!h) return '#';

    const m = h.match(
      /^https?:\/\/(www\.)?hatclub\.com(?!\/)(.+)$/
    );

    // Repairs:
    // https://www.hatclub.comanaheim-ducks
    if (m) {
      return '/collections/' + m[2];
    }

    return h;
  };

  const imgSrc = i => {
    if (!i) return '';

    let s =
      i.getAttribute('src') ||
      i.getAttribute('data-src') ||
      (i.getAttribute('srcset') || '').split(' ')[0] ||
      '';

    if (s.startsWith('data:')) {
      s = i.getAttribute('data-src') || '';
    }

    return s
      ? s.split('?')[0] + '?width=160'
      : '';
  };


  // ==================================================
  // HEADER MEGA MENU
  // ==================================================

  const header = document.querySelector(
    's-header.site-header'
  );

  const panels = document.querySelector(
    '#hcn-panels'
  );

  const topItems = document.querySelectorAll(
    '.hcn-top'
  );

  const scrim = document.querySelector(
    '.hcn-scrim'
  );

  let openId = null;
  let tOpen = null;
  let tClose = null;

  const setOpen = id => {
    openId = id;

	  topItems.forEach(li => {
      if (
        li.classList.contains(
          'hcn-top--team'
        )
      ) {
        return;
      }

      const a = li.querySelector('a');

      if (a) {
        const aID =
          a.getAttribute(
            'aria-controls'
          );

        const on =
          aID === id;

        a.setAttribute(
          'aria-expanded',
          on ? 'true' : 'false'
        );

        li.classList.toggle(
          'is-open',
          on
        );
      }
    });

    if (panels) {
      panels
        .querySelectorAll('.hcn-panel')
        .forEach(p => {
          p.classList.toggle(
            'is-open',
            p.id === id
          );
        });
    }

    if (scrim) {
      if (header) {
        scrim.style.setProperty(
          '--hcn-scrim-top',
          header.getBoundingClientRect().bottom +
            'px'
        );
      }

      scrim.classList.toggle(
        'is-open',
        !!id
      );
    }
  };


  topItems.forEach(li => {
    if (
      li.classList.contains(
        'hcn-top--team'
      )
    ) {
      //return;
    }

    const a = li.querySelector('a');

    if (!a) return;

    const id =
      a.getAttribute(
        'aria-controls'
      );

    li.addEventListener(
      'mouseenter',
      () => {
        clearTimeout(tClose);

        tOpen = setTimeout(
          () => setOpen(id),
          openId ? 0 : 120
        );
      }
    );

    li.addEventListener(
      'mouseleave',
      () => {
        clearTimeout(tOpen);

        tClose = setTimeout(
          () => setOpen(null),
          180
        );
      }
    );

    a.addEventListener(
      'keydown',
      e => {
        if (
          e.key === 'ArrowDown' ||
          e.key === ' '
        ) {
          e.preventDefault();

          setOpen(id);

          const f = $(
            `#${CSS.escape(id)} a`
          );

          if (f) {
            f.focus();
          }
        }
      }
    );
  });


  topItems.forEach(li => {
    li.addEventListener(
      'mouseenter',
      () => clearTimeout(tClose)
    );
  });


  if (panels) {
    panels.addEventListener(
      'mouseenter',
      () => clearTimeout(tClose)
    );

    panels.addEventListener(
      'mouseleave',
      () => {
        tClose = setTimeout(
          () => setOpen(null),
          180
        );
      }
    );
  }


  if (scrim) {
    scrim.addEventListener(
      'mouseenter',
      () => setOpen(null)
    );

    scrim.addEventListener(
      'click',
      () => setOpen(null)
    );
  }


  // ==================================================
  // SHOP MY TEAM DATA
  // ==================================================

  const shopMyTeamScript =
    document.querySelector(
      '#shop-my-team-json'
    );

  let shopMyTeamJson = [];

  if (shopMyTeamScript) {
    try {
      shopMyTeamJson = JSON.parse(
        shopMyTeamScript.textContent
      );

      if (!Array.isArray(shopMyTeamJson)) {
        shopMyTeamJson = [];
      }
    } catch (error) {
      console.error(
        'Shop My Team JSON error:',
        error
      );

      shopMyTeamJson = [];
    }
  }


  // ==================================================
  // DRAWER
  // ==================================================

  const drawer =
    $('.hcn-drawer');

  const backdropEl =
    $('[data-hcn-backdrop]');

  let lastFocus = null;

  const openDrawer = () => {
    if (!drawer) return;

    $$('.hcn-pane--sub', drawer)
      .forEach(p => {
        p.classList.remove('is-on');

        p.setAttribute(
          'aria-hidden',
          'true'
        );
      });

    lastFocus =
      document.activeElement;

    drawer.classList.add(
      'is-open'
    );

    drawer.setAttribute(
      'aria-hidden',
      'false'
    );

    if (backdropEl) {
      backdropEl.classList.add(
        'is-open'
      );
    }

    document.body.classList.add(
      'hcn-lock'
    );

    const first = $(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])',
      drawer
    );

    if (first) {
      first.focus();
    }
  };


  const closeDrawer = (
    keepLock = false
  ) => {
    if (!drawer) return;

    drawer.classList.remove(
      'is-open'
    );

    drawer.setAttribute(
      'aria-hidden',
      'true'
    );

    $$('.hcn-pane--sub', drawer)
      .forEach(p => {
        p.classList.remove(
          'is-on'
        );

        p.setAttribute(
          'aria-hidden',
          'true'
        );
      });

    if (!keepLock) {
      if (backdropEl) {
        backdropEl.classList.remove(
          'is-open'
        );
      }

      document.body.classList.remove(
        'hcn-lock'
      );

      if (
        lastFocus &&
        typeof lastFocus.focus ===
          'function'
      ) {
        lastFocus.focus();
      }

      lastFocus = null;
    }
  };


  // ==================================================
  // SHOP MY TEAM MODAL
  // ==================================================

  const modal =
    document.querySelector(
      '.hcn-modal'
    );

  // This function is assigned inside the modal
  // block and used by the global click handler.
  let openTeamModal = null;

  let closeTeamModal = null;


  if (modal) {
    const body =
      modal.querySelector(
        '.hcn-dbody'
      );

    const input =
      modal.querySelector(
        '.hcn-search input'
      );

    const grid =
      modal.querySelector(
        '.hcn-grid'
      );

    const heading =
      modal.querySelector(
        '.hcn-ghead h3'
      );

    const shopAllLink =
      modal.querySelector(
        '.hcn-ghead a'
      );

    let currentLeague = '';
    let searchText = '';


    // --------------------------------------------------
    // Team tile
    // --------------------------------------------------

    const tile = (
      team,
      leagueName = ''
    ) => {
      if (!team) return '';

      const href =
        fixHref(
          team.href ||
          team.url ||
          '#'
        );

      const name =
        team.name ||
        'Team';

      return `
        <a
          class="hcn-team"
          href="${esc(href)}"
        >
          ${
            team.logo
              ? `
                <img
                  src="${esc(team.logo)}"
                  alt=""
                  loading="lazy"
                >
              `
              : '<i></i>'
          }

          <span>${esc(name)}</span>

          
        </a>
      `;
    };


    // --------------------------------------------------
    // Render league teams
    // --------------------------------------------------

    const renderLeagueTeams =
      leagueName => {
        if (!leagueName) {
          if (grid) {
            grid.innerHTML = `
              <div class="hcn-empty">
                No teams found.
              </div>
            `;
          }

          return;
        }

        currentLeague =
          leagueName;

        const league =
          shopMyTeamJson.find(
            item =>
              item &&
              item.name &&
              String(item.name)
                .toLowerCase() ===
                String(leagueName)
                  .toLowerCase()
          );


        // ----------------------------------------------
        // Update selected tab
        // ----------------------------------------------

        modal
          .querySelectorAll(
            '.hcn-tab'
          )
          .forEach(tab => {
            const tabLeague =
              tab.getAttribute(
                'data-team'
              );

            const isSelected =
              tabLeague &&
              tabLeague.toLowerCase() ===
                String(
                  leagueName
                ).toLowerCase();

            tab.setAttribute(
              'aria-selected',
              isSelected
                ? 'true'
                : 'false'
            );
          });


        // ----------------------------------------------
        // Update heading
        // ----------------------------------------------

        if (heading) {
          heading.textContent =
            `${leagueName} Teams`;
        }


        // ----------------------------------------------
        // Update Shop All
        // ----------------------------------------------

        if (shopAllLink) {
          shopAllLink.textContent =
            `Shop all ${leagueName} →`;
        }


        // ----------------------------------------------
        // Render teams
        // ----------------------------------------------

        if (!league) {
          if (shopAllLink) {
            shopAllLink.removeAttribute(
              'href'
            );
          }

          if (grid) {
            grid.innerHTML = `
              <div class="hcn-empty">
                No teams found.
              </div>
            `;
          }

          return;
        }


        if (shopAllLink) {
          const shopUrl =
            league.url ||
            league.href;

          if (shopUrl) {
            shopAllLink.href =
              fixHref(shopUrl);
          } else {
            shopAllLink.removeAttribute(
              'href'
            );
          }
        }


        const query =
          searchText
            .trim()
            .toLowerCase();


        const hits =
          Array.isArray(
            league.teams
          )
            ? league.teams
                .filter(team => {
                  if (!team) {
                    return false;
                  }

                  const teamName =
                    String(
                      team.name ||
                        ''
                    );

                  // Don't show View All
                  const isViewAll =
                    teamName
                      .trim()
                      .toLowerCase() ===
                    'view all';

                  if (isViewAll) {
                    return false;
                  }

                  // No search
                  if (!query) {
                    return true;
                  }

                  // Search team name
                  return teamName
                    .toLowerCase()
                    .includes(
                      query
                    );
                })
                .map(team =>
                  tile(
                    team,
                    leagueName
                  )
                )
            : [];


        if (grid) {
          grid.innerHTML =
            hits.length
              ? hits.join('')
              : `
                <div class="hcn-empty">
                  No teams found.
                </div>
              `;
        }


        // Scroll content to top

        if (body) {
          body.scrollTop = 0;
        }


        // Open modal

        modal.classList.add(
          'is-open'
        );

        document.body.classList.add(
          'hcn-lock'
        );
      };


    // --------------------------------------------------
    // Close modal
    // --------------------------------------------------

    const closeModal = () => {
      modal.classList.remove(
        'is-open'
      );

      document.body.classList.remove(
        'hcn-lock'
      );

      if (
        lastFocus &&
        typeof lastFocus.focus ===
          'function'
      ) {
        lastFocus.focus();
      }

      lastFocus = null;
    };

    closeTeamModal =
      closeModal;


    // --------------------------------------------------
    // Open modal
    // --------------------------------------------------

    openTeamModal =
      leagueName => {
        // Remember original focus before anything
        // else changes focus.
        lastFocus =
          document.activeElement;

        // Close drawer completely.
        closeDrawer();

        setOpen(null);

        // If no league was supplied, use current
        // league or first available league.
        const requestedLeague =
          leagueName ||
          currentLeague ||
          shopMyTeamJson[0]?.name;

        if (!requestedLeague) {
          console.warn(
            'Shop My Team: no league available.'
          );

          return;
        }

        searchText = '';

        if (input) {
          input.value = '';
        }

        renderLeagueTeams(
          requestedLeague
        );

        modal.classList.add(
          'is-open'
        );

        document.body.classList.add(
          'hcn-lock'
        );

        const selected =
          modal.querySelector(
            `.hcn-tab[data-team="${CSS.escape(
              requestedLeague
            )}"]`
          );

        if (selected) {
          selected.scrollIntoView({
            inline: 'center',
            block: 'nearest'
          });
        }

        setTimeout(() => {
          const finePointer =
            window.matchMedia &&
            window.matchMedia(
              '(pointer:fine)'
            ).matches;

          if (
            finePointer &&
            input
          ) {
            input.focus();
          } else {
            const closeButton =
              $('.hcn-x', modal);

            if (closeButton) {
              closeButton.focus();
            }
          }
        }, 60);
      };


    // --------------------------------------------------
    // League tabs
    // --------------------------------------------------

    modal
      .querySelectorAll(
        '.hcn-tab'
      )
      .forEach(tab => {
        tab.addEventListener(
          'click',
          () => {
            const leagueName =
              tab.getAttribute(
                'data-team'
              );

            if (!leagueName) {
              return;
            }

            searchText = '';

            if (input) {
              input.value = '';
            }

            renderLeagueTeams(
              leagueName
            );
          }
        );
      });


    // --------------------------------------------------
    // Mobile Shop By Team Modal
    // --------------------------------------------------

    document
      .querySelector(
        '.hcn-row--team'
      )
      ?.addEventListener(
        'click',
        e => {
          e.preventDefault();

          openTeamModal(
            currentLeague ||
              shopMyTeamJson[0]?.name
          );
        }
      );


    // --------------------------------------------------
    // League chips
    // --------------------------------------------------

    document
      .querySelectorAll(
        '.hcn-chip'
      )
      .forEach(chip => {
        chip.addEventListener(
          'click',
          () => {
            const leagueName =
              chip.getAttribute(
                'data-team'
              );

            if (!leagueName) {
              return;
            }

            searchText = '';

            if (input) {
              input.value = '';
            }

            renderLeagueTeams(
              leagueName
            );
          }
        );
      });


    // --------------------------------------------------
    // Shop My Team top button
    // --------------------------------------------------

    document
      .querySelector(
        '.hcn-top--team button'
      )
      ?.addEventListener(
        'click',
        e => {
          e.preventDefault();

          openTeamModal(
            currentLeague ||
              shopMyTeamJson[0]?.name
          );
        }
      );


    // --------------------------------------------------
    // Search
    // --------------------------------------------------

    input?.addEventListener(
      'input',
      event => {
        searchText =
          event.currentTarget.value;

        if (currentLeague) {
          renderLeagueTeams(
            currentLeague
          );
        }
      }
    );


    // --------------------------------------------------
    // Modal click handling
    // --------------------------------------------------

    modal.addEventListener(
      'click',
      event => {
        // Click outside dialog
        if (
          event.target === modal
        ) {
          closeModal();
          return;
        }

        // Close button
        if (
          event.target.closest(
            '[data-hcn-close]'
          )
        ) {
          closeModal();
        }
      }
    );
  }


  // ==================================================
  // REBUY CART
  // ==================================================

  let cartEl = null;


  // --------------------------------------------------
  // Cart helper functions
  // --------------------------------------------------

  function cartElFunc() {

    if (!cartEl) {
      return;
    }

    console.log(
      'cartElFunc: Rebuy cart found'
    );


    // ------------------------------------------------
    // Free shipping confetti
    // ------------------------------------------------

    const confettiColors = [
      '#d0021b',
      '#00a23a',
      '#ffb400',
      '#111',
      '#2d9bff',
      '#ff5ea8'
    ];


    // ------------------------------------------------
    // Get shipping percentage
    // ------------------------------------------------

    const fsPercent = () => {
      const f = $(
        '.rebuy-cart__progress-bar-meter-fill'
      );

      if (!f) {
        return 0;
      }


      // Rebuy screen-reader percentage

      const sr = $(
        '.sr-only',
        f
      );

      const m =
        sr &&
        sr.textContent.match(
          /(\d+(?:\.\d+)?)\s*%/
        );

      if (m) {
        return parseFloat(m[1]);
      }


      // Fallback to inline width

      const w =
        (
          f.getAttribute('style') ||
          ''
        ).match(
          /width:\s*([\d.]+)%/
        );

      return w
        ? parseFloat(w[1])
        : 0;
    };


    const fsUnlocked = () =>
      fsPercent() >= 100;


    // ------------------------------------------------
    // Shipping meter styling
    // ------------------------------------------------

    const fsMeterState = () => {
      const meter = $(
        '.rebuy-cart__progress-bar-meter'
      );

      const fill = $(
        '.rebuy-cart__progress-bar-meter-fill'
      );

      if (!meter || !fill) {
        return;
      }

      const pct = Math.max(
        fsPercent(),
        1
      );

      const done =
        pct >= 100;

      meter.classList.toggle(
        'hcn-fs-complete',
        done
      );

      const paint =
        done
          ? 'done'
          : 'p' + pct;

      // Don't repaint every MutationObserver tick

      if (
        fill.dataset.hcnPaint ===
        paint
      ) {
        return;
      }

      fill.dataset.hcnPaint =
        paint;


      if (done) {
        fill.style.removeProperty(
          'background-image'
        );

        fill.style.removeProperty(
          'background-size'
        );

        fill.style.setProperty(
          'background',
          '#00a23a',
          'important'
        );
      } else {
        fill.style.setProperty(
          'background-image',
          'linear-gradient(90deg,#d0021b 0%,#ff6a00 35%,#f5c400 62%,#7ac70c 85%,#00a23a 100%)',
          'important'
        );

        fill.style.setProperty(
          'background-size',
          (
            (100 / pct) *
            100
          ).toFixed(1) +
            '% 100%',
          'important'
        );

        fill.style.setProperty(
          'background-repeat',
          'no-repeat',
          'important'
        );

        fill.style.setProperty(
          'background-color',
          'transparent',
          'important'
        );
      }
    };


    // ------------------------------------------------
    // Confetti
    // ------------------------------------------------

    const fsBurst = () => {
      const wrapEl = $(
        '.rebuy-cart__progress-bar-wrapper'
      );

      if (
        !wrapEl ||
        !fsUnlocked()
      ) {
        return;
      }

      const old = $(
        '.hcn-confetti',
        wrapEl
      );

      if (old) {
        old.remove();
      }

      const c =
        document.createElement(
          'div'
        );

      c.className =
        'hcn-confetti';

      c.innerHTML =
        Array.from(
          {
            length: 16
          },
          (_, i) => `
            <i
              style="
                left:${4 + i * 6 + Math.random() * 4}%;
                background:${confettiColors[i % confettiColors.length]};
                animation-delay:${(
                  Math.random() *
                  0.35
                ).toFixed(2)}s;
                animation-duration:${(
                  1.1 +
                  Math.random() *
                    0.7
                ).toFixed(2)}s;
              "
            ></i>
          `
        ).join('');

      wrapEl.appendChild(c);


      const prompt = $(
        '.rebuy-cart__progress-bar-prompt',
        wrapEl
      );

      if (prompt) {
        prompt.style.animation =
          'none';

        void prompt.offsetWidth;

        prompt.style.animation =
          '';
      }


      setTimeout(
        () => {
          if (c.isConnected) {
            c.remove();
          }
        },
        2600
      );


      // Checkout cue

      clearTimeout(
        W.__hcnCueTimer
      );

      W.__hcnCueTimer =
        setTimeout(
          () => {
            const checkoutBtn =
              $(
                '.rebuy-cart__checkout-button'
              );

            if (!checkoutBtn) {
              return;
            }

            checkoutBtn.classList.remove(
              'hcn-cta-cue'
            );

            void checkoutBtn.offsetWidth;

            checkoutBtn.classList.add(
              'hcn-cta-cue'
            );

            setTimeout(
              () =>
                checkoutBtn.classList.remove(
                  'hcn-cta-cue'
                ),
              1400
            );
          },
          3000
        );
    };


    // ------------------------------------------------
    // Animate shipping bar
    // ------------------------------------------------

    const fsCelebrate = () => {
      W.__hcnLastBurst =
        Date.now();

      const fill = $(
        '.rebuy-cart__progress-bar-meter-fill'
      );

      if (fill) {
        fill.style.transition =
          'none';

        fill.style.transform =
          'scaleX(0)';

        void fill.offsetWidth;

        fill.style.transition =
          'transform .85s cubic-bezier(.25,.8,.25,1)';

        fill.style.transform =
          'scaleX(1)';
      }

      setTimeout(
        fsBurst,
        900
      );
    };


    // ------------------------------------------------
    // Hide / change Rebuy titles
    // ------------------------------------------------

    const hideShipTitle = () => {
      $$(
        '.rebuy-cart__flyout h4.primary-title, .rebuy-cart__flyout .rebuy-widget h4'
      ).forEach(h => {
        if (
          /free standard shipping/i.test(
            h.textContent
          )
        ) {
          h.textContent =
            'You might also like';
        }

        if (
          /keep your hat clean/i.test(
            h.textContent
          )
        ) {
          const w =
            h.closest(
              '.rebuy-widget'
            ) ||
            h.parentElement;

          if (w) {
            w.classList.add(
              'hcn-hide-title'
            );
          }
        }
      });
    };


    // ------------------------------------------------
    // Checkout total
    // ------------------------------------------------

    const cartTotal = () => {
      const money =
        $$('.rebuy-cart__flyout *')
          .filter(
            e =>
              e.children.length === 0 &&
              /^\$\s?[\d,]+\.\d{2}$/.test(
                e.textContent.trim()
              )
          );

      const last =
        money[money.length - 1];

      return last
        ? last.textContent
            .trim()
            .replace(/\s+/g, '')
        : '';
    };


    const syncCheckout = () => {
      const label =
        $(
          '.rebuy-cart__checkout-button span'
        ) ||
        $(
          '.rebuy-cart__checkout-button'
        );

      if (!label) {
        return;
      }

      const total =
        cartTotal();

      if (!total) {
        return;
      }

      const want =
        'Checkout • ' +
        total;

      if (
        label.textContent.trim() !==
        want
      ) {
        label.textContent =
          want;
      }
    };


    // ------------------------------------------------
    // Trim recommendation variant labels
    // ------------------------------------------------

    const trimVariantLabels = () => {
      $$(
        '.rebuy-cart__flyout .rebuy-product-block select'
      ).forEach(sel => {
        if (
          sel.dataset
            .hcnTrimmed ===
          '1'
        ) {
          return;
        }

        const opts = [
          ...sel.options
        ];

        if (
          opts.length < 2
        ) {
          return;
        }

        const parts =
          opts.map(
            o =>
              o.textContent
                .trim()
                .split(' / ')
          );

        if (
          !parts.every(
            p =>
              p.length ===
              parts[0].length
          ) ||
          parts[0].length < 2
        ) {
          return;
        }

        let drop = 0;

        while (
          drop <
            parts[0].length - 1 &&
          parts.every(
            p =>
              p[drop] ===
              parts[0][drop]
          )
        ) {
          drop++;
        }

        if (!drop) {
          return;
        }

        opts.forEach(
          (o, i) => {
            o.textContent =
              parts[i]
                .slice(drop)
                .join(' / ');
          }
        );

        sel.dataset.hcnTrimmed =
          '1';
      });
    };


    // ------------------------------------------------
    // Style recommendation selects
    // ------------------------------------------------

    const styleRecSelects = () => {
      $$(
        '.rebuy-cart__flyout select.rebuy-select'
      ).forEach(sel => {
        const set = (
          k,
          v
        ) =>
          sel.style.setProperty(
            k,
            v,
            'important'
          );

        set(
          'appearance',
          'none'
        );

        set(
          '-webkit-appearance',
          'none'
        );

        set(
          'background-color',
          '#fff'
        );

        set(
          'background-image',
          'linear-gradient(45deg,transparent 50%,#000 50%),linear-gradient(135deg,#000 50%,transparent 50%)'
        );

        set(
          'background-position',
          'calc(100% - 20px) 15px,calc(100% - 15px) 15px'
        );

        set(
          'background-size',
          '5px 5px,5px 5px'
        );

        set(
          'background-repeat',
          'no-repeat'
        );

        set(
          'padding',
          '0 34px 0 14px'
        );

        set(
          'text-align',
          'center'
        );
      });
    };


    // ------------------------------------------------
    // Visible scrollbar
    // ------------------------------------------------

    const markScroller = () => {
      const sc =
        $$('.rebuy-cart__flyout *')
          .find(e => {
            const cs =
              getComputedStyle(e);

            return (
              /auto|scroll/.test(
                cs.overflowY
              ) &&
              e.scrollHeight >
                e.clientHeight +
                  20
            );
          });

      if (sc) {
        sc.classList.add(
          'hcn-cart-scroll'
        );
      }
    };


    // ------------------------------------------------
    // Recommendation rail arrows
    // ------------------------------------------------

    const buildRailArrows = () => {
      const widget =
        $$('.rebuy-cart__flyout .rebuy-widget')
          .find(w => {
            const t = $(
              '.splide__track',
              w
            );

            return (
              t &&
              t.scrollWidth >
                t.clientWidth + 10
            );
          });

      if (
        !widget ||
        $('.hcn-rail-head', widget)
      ) {
        return;
      }

      const h4 = $(
        'h4.primary-title',
        widget
      );

      const track = $(
        '.splide__track',
        widget
      );

      if (!h4 || !track) {
        return;
      }

      const head =
        document.createElement(
          'div'
        );

      head.className =
        'hcn-rail-head';

      h4.parentNode.insertBefore(
        head,
        h4
      );

      head.appendChild(h4);


      const mk = dir => {
        const b =
          document.createElement(
            'button'
          );

        b.type =
          'button';

        b.className =
          'hcn-rail-arrow';

        b.setAttribute(
          'aria-label',
          dir < 0
            ? 'Scroll recommendations left'
            : 'Scroll recommendations right'
        );

        b.innerHTML = `
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="#000"
            stroke-width="2.5"
            aria-hidden="true"
          >
            <path
              d="${
                dir < 0
                  ? 'M15 4l-8 8 8 8'
                  : 'M9 4l8 8-8 8'
              }"
            />
          </svg>
        `;

        b.addEventListener(
          'click',
          () => {
            track.scrollBy({
              left:
                dir * 182,
              behavior:
                'smooth'
            });
          }
        );

        return b;
      };


      const arrows =
        document.createElement(
          'div'
        );

      arrows.className =
        'hcn-rail-arrows';

      const L = mk(-1);
      const R = mk(1);

      arrows.append(
        L,
        R
      );

      head.appendChild(
        arrows
      );


      const upd = () => {
        L.disabled =
          track.scrollLeft <
          4;

        R.disabled =
          track.scrollLeft >=
          track.scrollWidth -
            track.clientWidth -
            4;
      };


      track.addEventListener(
        'scroll',
        upd,
        {
          passive: true
        }
      );

      upd();
    };


    // ------------------------------------------------
    // Size placeholder
    // ------------------------------------------------

    const addSizePlaceholder = () => {
      $$(
        '.rebuy-cart__flyout select.rebuy-select'
      ).forEach(sel => {
        if (
          sel.dataset
            .hcnPlaceholder ===
            '1' ||
          sel.options.length <
            2
        ) {
          return;
        }

        const o =
          document.createElement(
            'option'
          );

        o.value = '';

        o.textContent =
          'Select size';

        o.disabled = false;

        sel.insertBefore(
          o,
          sel.firstChild
        );

        sel.value = '';

        sel.dataset
          .hcnPlaceholder =
          '1';
      });
    };


    // ------------------------------------------------
    // Run initial Rebuy styling
    // ------------------------------------------------

    hideShipTitle();

    trimVariantLabels();

    addSizePlaceholder();

    styleRecSelects();

    markScroller();

    buildRailArrows();

    syncCheckout();


    // ------------------------------------------------
    // Run when cart opens
    // ------------------------------------------------

    const fsRun = () => {
      if (!cartEl) {
        return;
      }

      hideShipTitle();

      trimVariantLabels();

      addSizePlaceholder();

      styleRecSelects();

      markScroller();

      buildRailArrows();

      syncCheckout();


      const fill = $(
        '.rebuy-cart__progress-bar-meter-fill'
      );

      if (!fill) {
        return;
      }


      fill.style.transition =
        'none';

      fill.style.transform =
        'scaleX(0)';

      void fill.offsetWidth;

      fill.style.transition =
        'transform .85s cubic-bezier(.25,.8,.25,1)';

      fill.style.transform =
        'scaleX(1)';


      fsMeterState();


      const meterEl = $(
        '.rebuy-cart__progress-bar-meter'
      );

      if (meterEl) {
        meterEl.dataset.hcnPct =
          fsPercent();
      }


      if (fsUnlocked()) {
        W.__hcnLastBurst =
          Date.now();

        setTimeout(
          fsBurst,
          900
        );
      }
    };


    // ------------------------------------------------
    // Detect crossing 100%
    // ------------------------------------------------

    const checkThreshold = () => {
      fsMeterState();

      const meter = $(
        '.rebuy-cart__progress-bar-meter'
      );

      if (!meter) {
        return;
      }

      const now =
        fsUnlocked();

      const before =
        meter.dataset.hcnPct ===
        undefined
          ? null
          : parseFloat(
              meter.dataset.hcnPct
            );

      meter.dataset.hcnPct =
        fsPercent();

      const justCrossed =
        now &&
        before !== null &&
        before < 100;

      const recently =
        Date.now() -
          +(W.__hcnLastBurst ||
            0) <
        4000;


      if (
        justCrossed &&
        !recently &&
        cartEl &&
        cartEl.classList.contains(
          'is-visible'
        )
      ) {
        W.__hcnLastBurst =
          Date.now();

        setTimeout(
          fsCelebrate,
          650
        );
      }
    };


    // ------------------------------------------------
    // Mutation observer
    // ------------------------------------------------

    let syncT = null;

    const totalObs =
      new MutationObserver(
        () => {
          clearTimeout(syncT);

          syncT =
            setTimeout(
              () => {
                syncCheckout();

                trimVariantLabels();

                addSizePlaceholder();

                styleRecSelects();

                markScroller();

                buildRailArrows();

                checkThreshold();
              },
              120
            );
        }
      );


    const flyoutEl = $(
      '.rebuy-cart__flyout'
    );


    if (flyoutEl) {
      totalObs.observe(
        flyoutEl,
        {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: [
            'class',
            'style'
          ]
        }
      );
    }


    // ------------------------------------------------
    // Cart open observer
    // ------------------------------------------------

    const fsObs =
      new MutationObserver(
        () => {
          if (
            cartEl &&
            cartEl.classList.contains(
              'is-visible'
            )
          ) {
            setTimeout(
              fsRun,
              180
            );
          }
        }
      );


    if (cartEl) {
      fsObs.observe(
        cartEl,
        {
          attributes: true,
          attributeFilter: [
            'class'
          ]
        }
      );
    }


    // ------------------------------------------------
    // Cleanup
    // ------------------------------------------------

    W.__hcnFsTeardown =
      () => {
        fsObs.disconnect();

        totalObs.disconnect();

        clearTimeout(
          syncT
        );

        clearTimeout(
          W.__hcnCueTimer
        );
      };
  }


  // ==================================================
  // WAIT FOR REBUY CART
  // ==================================================

  const waitForElement = (
    selector,
    callback
  ) => {
    const existing =
      document.querySelector(
        selector
      );

    if (existing) {
      callback(existing);
      return;
    }


    const observer =
      new MutationObserver(
        () => {
          const element =
            document.querySelector(
              selector
            );

          if (element) {
            observer.disconnect();

            if (
              W.__hcnRebuyWaitObserver ===
              observer
            ) {
              W.__hcnRebuyWaitObserver =
                null;
            }

            callback(element);
          }
        }
      );


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );


    W.__hcnRebuyWaitObserver =
      observer;
  };


  // ==================================================
  // START REBUY WATCHER
  // ==================================================

  waitForElement(
    '.rebuy-cart',
    foundCart => {
      cartEl =
        foundCart;

      if (W.__hcnFsTeardown) {
        W.__hcnFsTeardown();

        W.__hcnFsTeardown =
          null;
      }

      cartElFunc();
    }
  );


  // ==================================================
  // GLOBAL HANDLERS
  // ==================================================

  const onClick = e => {
    // ----------------------------------------------
    // Burger
    // ----------------------------------------------

    const burger =
      e.target.closest(
        '.site-header__menu-trigger--open'
      );

    if (burger) {
      e.preventDefault();

      e.stopImmediatePropagation();

      openDrawer();

      return;
    }


    // ----------------------------------------------
    // Team / league trigger
    // ----------------------------------------------

    const teamTrigger =
      e.target.closest(
        '[data-hcn-team]'
      );

    if (
      teamTrigger &&
      openTeamModal
    ) {
      e.preventDefault();

      const leagueName =
        teamTrigger.dataset
          .hcnTeam;

      openTeamModal(
        leagueName
      );

      return;
    }


    // ----------------------------------------------
    // Drawer close button / backdrop
    // ----------------------------------------------

    if (
      drawer &&
      (
        e.target.closest(
          '[data-hcn-dclose]'
        ) ||
        e.target ===
          backdropEl
      )
    ) {
      e.preventDefault();

      closeDrawer();

      return;
    }


    // ----------------------------------------------
    // Drawer sub-pane open
    // ----------------------------------------------

    const s =
      e.target.closest(
        '[data-hcn-sub]'
      );

    if (
      s &&
      drawer &&
      drawer.contains(s)
    ) {
      e.preventDefault();

      const sub =
        s.dataset.hcnSub;

      if (!sub) {
        return;
      }

      const pane =
        $(
          `.hcn-pane--sub[data-sub="${CSS.escape(
            sub
          )}"]`,
          drawer
        );

      if (pane) {
        pane.classList.add(
          'is-on'
        );

        pane.setAttribute(
          'aria-hidden',
          'false'
        );

        const first = $(
          'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])',
          pane
        );

        if (first) {
          first.focus();
        }
      }

      return;
    }


    // ----------------------------------------------
    // Drawer back button
    // ----------------------------------------------

    const back =
      e.target.closest(
        '[data-hcn-back]'
      );

    if (
      back &&
      drawer &&
      drawer.contains(back)
    ) {
      e.preventDefault();

      const pane =
        back.closest(
          '.hcn-pane--sub'
        );

      if (pane) {
        pane.classList.remove(
          'is-on'
        );

        pane.setAttribute(
          'aria-hidden',
          'true'
        );

        const sub =
          pane.dataset.sub;

        if (sub) {
          const trigger =
            $(
              `[data-hcn-sub="${CSS.escape(
                sub
              )}"]`,
              drawer
            );

          if (trigger) {
            trigger.focus();
          }
        }
      }

      return;
    }
  };


  const onKey = e => {
    if (
      e.key !== 'Escape'
    ) {
      return;
    }


    // ----------------------------------------------
    // Modal
    // ----------------------------------------------

    if (
      modal &&
      modal.classList.contains(
        'is-open'
      )
    ) {
      if (closeTeamModal) {
        closeTeamModal();
      }

      return;
    }


    // ----------------------------------------------
    // Drawer
    // ----------------------------------------------

    if (
      drawer &&
      drawer.classList.contains(
        'is-open'
      )
    ) {
      const openSub =
        $('.hcn-pane--sub.is-on', drawer);

      if (openSub) {
        openSub.classList.remove(
          'is-on'
        );

        openSub.setAttribute(
          'aria-hidden',
          'true'
        );

        const sub =
          openSub.dataset.sub;

        if (sub) {
          const trigger =
            $(
              `[data-hcn-sub="${CSS.escape(
                sub
              )}"]`,
              drawer
            );

          if (trigger) {
            trigger.focus();
          }
        }

        return;
      }

      closeDrawer();

      return;
    }


    // ----------------------------------------------
    // Mega menu
    // ----------------------------------------------

    if (openId) {
      setOpen(null);
    }
  };


  // ==================================================
  // GLOBAL EVENTS
  // ==================================================

  document.addEventListener(
    'click',
    onClick,
    true
  );

  document.addEventListener(
    'keydown',
    onKey
  );


  // ==================================================
  // GLOBAL CLEANUP
  // ==================================================

  W.__hcnCleanup = () => {
    // Stop Rebuy wait observer

    if (
      W.__hcnRebuyWaitObserver
    ) {
      W.__hcnRebuyWaitObserver.disconnect();

      W.__hcnRebuyWaitObserver =
        null;
    }


    // Stop Rebuy observers

    if (
      W.__hcnFsTeardown
    ) {
      W.__hcnFsTeardown();

      W.__hcnFsTeardown =
        null;
    }


    // Remove global handlers

    document.removeEventListener(
      'click',
      onClick,
      true
    );

    document.removeEventListener(
      'keydown',
      onKey
    );


    // Close UI

    if (modal) {
      modal.classList.remove(
        'is-open'
      );
    }

    if (drawer) {
      drawer.classList.remove(
        'is-open'
      );
    }

    if (backdropEl) {
      backdropEl.classList.remove(
        'is-open'
      );
    }


    document.body.classList.remove(
      'hcn-lock'
    );


    // Close mega menu

    setOpen(null);


    // Timers

    clearTimeout(
      tOpen
    );

    clearTimeout(
      tClose
    );

    clearTimeout(
      W.__hcnCueTimer
    );


    // Reset references

    openTeamModal =
      null;

    closeTeamModal =
      null;

    cartEl =
      null;
  };

  /* PDP gallery lightbox: click an image to open a scrollable overlay of all images */
  let lightbox = null;
  if ($('.product__images')) {
    lightbox = document.createElement('div');
    lightbox.className = 'hcn-lb';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Product images');
    lightbox.innerHTML = '<div class="hcn-lb__scroll"></div><button class="hcn-lb__x" aria-label="Close">\u2715</button><div class="hcn-lb__count"></div>';
    document.body.appendChild(lightbox);
    const lbScroll = $('.hcn-lb__scroll', lightbox), lbCount = $('.hcn-lb__count', lightbox);
    const galImgs = () => $$('.product__images .swiper-slide picture img');
    const figs = () => $$('.hcn-lb__fig', lbScroll);
    const lbCountUpdate = () => {
      const f = figs(), mid = lbScroll.scrollTop + lbScroll.clientHeight / 2;
      let idx = 0; f.forEach((el, i) => { if (el.offsetTop <= mid) idx = i; });
      lbCount.textContent = (idx + 1) + ' / ' + f.length;
    };
    const lbOpen = i => {
      lbScroll.innerHTML = galImgs().map(im => `<figure class="hcn-lb__fig"><img src="${(im.currentSrc || im.src).replace(/\?.*$/, '')}" alt="${esc(im.getAttribute('alt') || '')}"></figure>`).join('');
      lightbox.classList.add('is-open');
      document.body.classList.add('hcn-lock');
      const f = figs();
      lbScroll.style.scrollBehavior = 'auto';
      lbScroll.scrollTop = f[i] ? f[i].offsetTop - 24 : 0;
      lbScroll.style.scrollBehavior = 'smooth';
      lbCountUpdate();
      $('.hcn-lb__x', lightbox).focus();
    };
    const lbClose = () => { lightbox.classList.remove('is-open'); document.body.classList.remove('hcn-lock'); };
    const lbStep = d => {
      const f = figs(), mid = lbScroll.scrollTop + 40;
      let idx = 0; f.forEach((el, i) => { if (el.offsetTop <= mid) idx = i; });
      const n = Math.min(f.length - 1, Math.max(0, idx + d));
      lbScroll.scrollTo({ top: f[n].offsetTop - 24 });
    };
    lbScroll.addEventListener('scroll', lbCountUpdate, { passive: true });
    const lbClick = e => {
      const im = e.target.closest('.product__images .swiper-slide picture img');
      if (im) { e.preventDefault(); e.stopPropagation(); const i = galImgs().indexOf(im); return lbOpen(i < 0 ? 0 : i); }
      if (e.target.closest('.hcn-lb__x') || e.target === lightbox || e.target === lbScroll) lbClose();
    };
    const lbKey = e => {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.stopPropagation(); lbClose(); }
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); lbStep(1); }
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); lbStep(-1); }
    };
    document.addEventListener('click', lbClick, true);
    document.addEventListener('keydown', lbKey, true);
    galImgs().forEach(im => { im.style.cursor = 'zoom-in'; });
    W.__hcnLbTeardown = () => {
      document.removeEventListener('click', lbClick, true);
      document.removeEventListener('keydown', lbKey, true);
      lightbox.remove();
    };
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        console.log(cart);
        document.querySelectorAll('.site-header__bag-count')
          .forEach(el => { 
            el.textContent = cart.item_count; 
            if (cart.item_count > 0) {
              el.classList.remove('hidden');
            } else {
              el.classList.add('hidden'); 
            }
          });
      });
  }
  document.addEventListener('rebuy:cart.change', updateCartCount);
  document.addEventListener('rebuy:cart.add', updateCartCount);

})();